import {
    AfterViewChecked,
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewChild
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CommonDataService} from 'app/services/common-data.service';
import {ISubscription} from "rxjs/Subscription";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_rangeSelector from "@amcharts/amcharts4/plugins/rangeSelector";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4lang_ru_RU from "@amcharts/amcharts4/lang/ru_RU"
import am4lang_uk_UA from "@amcharts/amcharts4/lang/uk_UA"
import am4lang_lt_LT from "@amcharts/amcharts4/lang/lt_LT"
import am4lang_pl_PL from "@amcharts/amcharts4/lang/pl_PL"
import am4lang_en from "@amcharts/amcharts4/lang/en"
import {ChartData} from "../../models/chart-data";
import * as moment from "moment";
import {ChartLineModel} from "../../models/amchart/chart-line-model";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {
    ChartAggDataBuffer,
    ChartAggDataSales,
    ChartAggDatesModel,
    ChartAggModel
} from "../../models/amchart/chart-aggregation";
import {BufferGraphService} from "../../services/buffer-graph.service";
import {ChartSetDataModel} from "../../models/amchart/chart-exchange";
import {ChartListProps} from "../../models/amchart/chart-list-props";
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {StocksFilter} from "../../../stocks/models/stocks-filter";
import {ChartPeriodSelectorComponent} from "../chart-period-selector.component/chart-period-selector.component";
import {AddChartModel} from "../../models/amchart/add-chart-model";
import {CompareItem} from "../../models/compare-item";
import * as Popper from 'popper.js/dist/umd/popper';
import {CommonService} from "../../../services/common.service";
import {BGChartType} from "../../models/b-g-chart-type";
import {SummaryLineDataName} from "../../models/summary-line-data";
import {
    GenerateLinesGUID,
    HoverLineGUID,
    LoadingSummaryLineDataGUID,
    RangeAggGUID,
    UpdateChartAggGUID,
    UpdateChartGUID,
    UpdateInfoParamGUID,
    UpdateStaticPopupGUID
} from "../../models/update-static-popup-GUID";
import {Fresh} from "../../../shared/models/fresh";
import Timer = NodeJS.Timer;

am4core.useTheme(am4themes_animated);


@Component({
    selector: 'amchart4',
    templateUrl: './amchart4.component.html',
    styleUrls: ['../../styles/common-chart.css', '../chart-info.component/chart-info.component.css' ,'./amchart4.component.css', '../../../../../node_modules/animate.css/animate.min.css']
})
export class Amchart4Component implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                private readonly graphService: BufferGraphService,
                public readonly commonData: CommonDataService,
                private readonly dataExchange: BufferGraphDataExchangeService,
                private commonService: CommonService,
                private readonly zone: NgZone){
        this.initialise();
        //this.setChartProps();

    }

    private initialise = (): void => {
        this.legendVisible = false;
        this.helper = new ChartHelper();
        this.lines = {};
        this.bubbleLines = {};
        this.agg = [];
        this.lgHeight = 0;
        this.bubbleVisible = true;
        this.cwhItemId = 0;
        this.compareItems = [];
        this.closeOut = new EventEmitter<boolean>();
        this.loading = new EventEmitter<boolean>();
        this.customListsPopper = null;
        this.hideCompareBtn = true;
        // this.showAgg = true;
        this.bubbleLinesQnt = 1;
        this.lockCursor = {main: false, bubble: false, summaryLine: false};
        this.mainChartMarginLeft = 0;
        this.bubbleChartMarginLeft = 0;
        this.summaryLineChartMarginLeft = 0;
        //this.isMainChart= true;
    };

    @Input() public chartData: ChartData;

    @Input() public isAdmin: boolean;

    @Input() public type: BGChartType;

    @Input() public GUID: string;

    @Input() public sharedGUID?: string;

    @Input() public isMainChart: boolean;

    @Input() public hasCompareChart: boolean;

    @Input()
    private set wrpWidth(val: number){
        this.chartWrpWidth = val;
    };

    @Output()
    private closeOut: EventEmitter<boolean>;

    @Output()
    private loading: EventEmitter<boolean>;

    @ViewChild('mainWrapper')
    public mainWrapperRef: ElementRef;

    @ViewChild('legenddiv')
    private legenddiv: ElementRef;

    @ViewChild('wrhListBtn')
    public wrhListBtn: ElementRef;

    @ViewChild('tabsListBtn')
    private tabsListBtn: ElementRef;

    @ViewChild('customListBtn')
    private customListBtn: ElementRef;

    @ViewChild('customListAnchor')
    private customListAnchor: ElementRef;

    @ViewChild('customListsWrp')
    private customListsWrp: ElementRef;

    @ViewChild('showCompBtn')
    private showCompBtn: ElementRef;

    @ViewChild('btnWrpCompare')
    private btnWrpCompare: ElementRef;

    @ViewChild('chartHeader')
    private chartHeader: ElementRef;

    @ViewChild('summaryLineWrp')
    private summaryLineWrp: ElementRef;

    @ViewChild('mainChartWrp')
    private mainChartWrp: ElementRef;

    @ViewChild('bubbleChartWrp')
    private bubbleChartWrp: ElementRef;

    @ViewChild('chartsWrp')
    private chartsWrp: ElementRef;

    @ViewChild('chartPeriodSelector')
    private chartPeriodSelector: ChartPeriodSelectorComponent;

    private subscriptionShowTargetLevel: ISubscription;
    private subscriptionUpdateChartData: ISubscription;
    private subscriptionToggleBubbleChart: ISubscription;
    private subscriptionToggleChartInfo: ISubscription;
    private subscriptionUpdateChartZoom: ISubscription;
    private subscriptionUpdateCustomChartPopper: ISubscription;
    private subscriptionUpdateLineVisibility: ISubscription;
    private subscriptionCompareChartReady: ISubscription;
    private subscriptionSetGlass: ISubscription;
    private subscriptionSetHover: ISubscription;
    private subscriptionLoadSummaryLineData: ISubscription;
    private subscriptionCalcAgg: ISubscription;
    private subscriptionUpdateChartDimensions: ISubscription;

    // private chart: am4charts.XYChart;
    private chart: any;
    // private bubbleChart: am4charts.XYChart;
    private bubbleChart: any;
    private summaryLineChart: any;
    private axisChart: any;
    public infoChartLine: ChartLineModel[];
    public lines: any;
    public bubbleLines: any;
    public linesChartLine: any;
    private bubbleChartData: any[];
    public chartLines: ChartLineModel[];
    public bubbleChartLines: ChartLineModel[];
    private bubbleChartXAxis: any;
    private bubbleChartYAxis: any;
    private chartXAxis: any;
    private chartYAxis: any;
    private axisChartXAxis: any;
    private axisChartYAxis: any;
    private chartYAxisRepTime: any;
    private chartYAxisLifeTime: any;
    private chartYAxisBalanceAm: any;
    private summaryLineChartXAxis: any;
    private summaryLineChartYAxis: any;
    private summaryLineChartYAxis2: any;
    // private bubbleChartCursor: any;
    public helper: ChartHelper;
    public agg: ChartAggModel[];
    public aggPeriod: string;
    public legendVisible: boolean;
    public legendBubbleVisible: boolean;
    public _bubbleVisible: boolean;
    private translates: any;
    // private listenResize: () => void;
    private lgHeight: number;
    private sku: string;
    private warehouseCode: string;
    private itemId: number;
    public showInfo: boolean;
    public cwhItemId: number;
    public compareItems: CompareItem[];
    private chartReady: boolean;
    private bubbleChartReady: boolean;
    public showWrhList: boolean;
    public showCustomLists: boolean;
    public addItemGUID: string;
    // public stpDate: string;
    public hideCompareBtn: boolean;
    // public showAgg: boolean;
    public rightAxis: boolean;
    public _chartWrpWidth: number;
    public showGlass: boolean;

    private customListsPopper: Popper;
    private customListsPopperCreate: boolean;
    public compareButtonsPopperUpdate: boolean;
    private compareButtonsPopper: Popper;
    public showTabsList: boolean;
    private CTRLPressed: boolean;
    public freezeDataChange: boolean;
    public id: string;
    // public savedRange: any;
    public savedZoom: { start: Date, end: Date };
    public bubbleLinesQnt: number;
    public loadingSummaryLineData: boolean;
    public summaryLineSelected: ChartLineModel;
    public zoomStartDate: Date;
    public zoomEndDate: Date;
    public lockCursor: {main: boolean, bubble: boolean, summaryLine: boolean};
    public cursorTimeout: Timer;
    public blockMainChartCursor: boolean;
    public blockBubbleChartCursor: boolean;
    public blockSummaryLineChartCursor: boolean;

    public mainChartMarginLeft: number;
    public bubbleChartMarginLeft: number;
    public summaryLineChartMarginLeft: number;

    public mainChartWidth: number;
    public bubbleChartWidth: number;
    public summaryLineChartWidth: number;
    public summaryLineChartNameLeftPosition: number;
    public interval: Timer;

    public entered: boolean;
    public x: number;
    public y: number;
    public top: number;
    public left: number;
    public width: number;
    public height: number;
    public horLineLeft: number;
    public horLineTop: number;
    public timeOut: Timer;


    // public tabs: CodeNameChartTabs;

    @HostListener('window:resize', ['$event'])
    private onResize = (): void => {
        if (this.customListsPopper){
            this.customListsPopper.update();
        }
        this.helper.wait(() =>this.chart && this.updateCursor(), 1500);
    }

    @HostListener('document:keyup', ['$event'])
    private onKeyUp = (e: KeyboardEvent): void => {
        this.CTRLPressed = e.ctrlKey;
    }

    @HostListener('document:keydown', ['$event'])
    private onKeyDown = (e: KeyboardEvent): void => {
        this.CTRLPressed = e.ctrlKey;
    }

    async ngOnInit(){
        this.id = this.type + 'Chart' + this.isMainChart ? 'Main' : '';
        this.translates = await this.translateService.get(['NoData', 'Date', 'OffShort', 'OnShort', 'Rows', 'Goods', 'Warehouses']).toPromise();

        let chartLines = await this.helper.genChartProps(this.translateService, this.commonService,
            this.helper.getTypeChart(this.type), this.isAdmin);
        let bubbleChartLines = await this.helper.genBubbleChartProps(this.translateService, this.commonService,
            this.helper.getTypeChart(this.type), this.isAdmin);
        for (let i = 0; i < chartLines.length; i++){
            if (chartLines[i].name === 'actionBuffer'){
                chartLines[i].lineNamePopup = await this.translateService.get('MainChart_BufferGAll').toPromise();
            } else if (chartLines[i].name === 'actionSafetyBuffer'){
                chartLines[i].lineNamePopup = await this.translateService.get('MainChart_ActionSafetyBufferAll').toPromise();
            }
        }

        this.chartLines = chartLines;
        this.bubbleChartLines = bubbleChartLines;

        // console.log(this.chartLines, this.bubbleChartLines, this.sharedGUID, 'ngOnInit')

        if (this.isMainChart){
            this.dataExchange.generateInfoLines(new GenerateLinesGUID(this.sharedGUID, this.chartLines, this.bubbleChartLines));
        }

        if (!this.GUID){
            // this.GUID = this.helper.generateGUID();
            // this.isMainChart = false
        } else{
            this.addItemGUID = this.helper.generateGUID();
            this.addToListProps(this.addItemGUID);
        }


        // this.listenResize = this.renderer.listen('body', 'resize', this.updateLgHeight);
        //this.generateBubbleChartData();

        this.sku = this.chartData.itemInfo.sku;
        this.warehouseCode = this.chartData.itemInfo.warehouseCode;
        this.itemId = this.chartData.itemInfo.itemId;

        this.addToListProps();
        this.updateCWHItemId();

        console.log(this.chartData, 'ngOnInit');
    }

    ngAfterViewInit(){
        this.zone.runOutsideAngular(() => {
            this.interval = setInterval(() => {
                if (this.chartLines && this.bubbleChartLines && this.chartLines.length && this.bubbleChartLines.length){
                    clearInterval(this.interval);
                    this.interval = null;
                    // this.helper.wait(() => {
                    this.generateGraph();
                    if (!this.isMainChart){
                        this.helper.wait(() => this.updateCursor(), 5000)
                        this.helper.wait(() => this.updateCursor(), 10000)
                    }
                    // this.generateBubbleChart();
                    this.generateBubbleChartData();
                    this.bubbleChart.data = this.bubbleChartData;
                    this.bubbleChart.validateData();
                    this.dataExchange.updateChartObj(new UpdateChartGUID(
                        this.sharedGUID,
                        this.chart,
                        this.chartXAxis,
                        this.chartData,
                        this.bubbleChart,
                        this.bubbleChartXAxis,
                        this.bubbleChartData,
                        this.isMainChart
                    ))

                    this.generateLineGraph();
                    this.generateAxisChart();
                    // }, 1000)

                    //# show target level on chart
                    this.subscriptionShowTargetLevel = this.dataExchange.showTargetLevelCurrent.subscribe(r =>
                        this.helper.tryCatch(() => r !== null ? this.showTargetLevel(r) : null)
                    );
                    //# update chart data
                    this.subscriptionUpdateChartData = this.dataExchange.updateChartDataCurrent.subscribe(r => this.helper.tryCatch(() => {
                        this.updateChartData(r);
                        this.updateCursor();
                    }));

                    //# toggle visibility bubble chart for main and compare chart
                    this.subscriptionToggleBubbleChart = this.dataExchange.toggleBubbleChartCurrent.subscribe((r: { type: BGChartType, sharedGUID: string, show: boolean }) =>
                        this.helper.tryCatch(() =>{
                            if (r && (this.type === r.type || this.sharedGUID === r.sharedGUID)){
                                this.bubbleVisible = r.show;
                                this.updateCursor();
                            }
                        })
                    );

                    //# toggle visibility info for main and compare chart
                    this.subscriptionToggleChartInfo = this.dataExchange.toggleChartInfoCurrent.subscribe((r: { type: BGChartType, sharedGUID: string, show: boolean }) =>
                        this.helper.tryCatch(() => {
                            if (r && (this.type === r.type || this.sharedGUID === r.sharedGUID)){
                                this.showInfo = r.show;
                                this.helper.wait( () => {
                                    this.calcChartsDimensions();
                                    this.updateCursor();
                                },50);
                            }

                            this.chartWrpWidth = Math.random() * 1000;
                        })
                    );

                    //# update zoom for main and compare chart
                    this.subscriptionUpdateChartZoom = this.dataExchange.updateChartZoomCurrent.subscribe((r: { type: BGChartType, sharedGUID: string, start: Date, end: Date }) =>
                        this.helper.tryCatch(() => r && (this.type === r.type || this.sharedGUID === r.sharedGUID) ? this.updateZoom(r.start, r.end) : null)
                    );

                    //# update popper for
                    this.subscriptionUpdateCustomChartPopper = this.dataExchange.customChartPopperUpdateCurrent.subscribe(r =>
                        this.helper.tryCatch(() => r && this.customListsPopper ? this.popperUpd() : null)
                    );

                    //# toggle visibility lines in charts, main and compare chart
                    this.subscriptionUpdateLineVisibility = this.dataExchange.toggleLinesVisibilityCurrent.subscribe(r =>
                        this.helper.tryCatch(() => this.helper.wait(() => this.updateLineVisibility(r)))
                    );

                    //# sync in compare chart lines and props
                    this.subscriptionCompareChartReady = this.dataExchange.compareChartReadyCurrent.subscribe(
                        (r: { command: string, type: string, sharedGUID: string, lines: ChartLineModel[] }) =>
                            this.helper.tryCatch(() =>{
                                    if (r){
                                        if (r.sharedGUID === this.sharedGUID){
                                            switch (r.command){
                                                case 'ready': this.sendLinesPropsToCompareChart(r); break;
                                                case 'update': this.setLinesProps(r); break;
                                                case 'remove': break;
                                                default: this.setLinesProps(r);
                                            }
                                        }
                                    }
                            }
                       )
                    );

                    //# toggle visibility lines in charts, main and compare chart
                    this.subscriptionSetGlass = this.dataExchange.glassCurrent.subscribe((r: { sharedGUID: string, showGlass: boolean }) =>
                        this.helper.tryCatch(() => r && r.sharedGUID === this.sharedGUID ? this.showGlass = r.showGlass : null)
                    );

                    //# toggle hover lines in charts, main and compare chart
                    this.subscriptionSetHover = this.dataExchange.chartHoverLinesCurrent.subscribe((r: HoverLineGUID) =>
                        this.helper.tryCatch(() => {
                            if (r && r.GUID === this.sharedGUID){
                                switch (r.chart){
                                    case 'line': this.lines[r.lineName].segments
                                        ? this.lines[r.lineName].segments.each(segment => segment.isHover = r.hover)
                                        : this.lines[r.lineName].columns.each(column => column.isHover = r.hover); break;
                                    case 'bubble': this.bubbleLines[r.lineName].bulletData.isHover = r.hover; break;
                                }
                            }
                        })
                    );

                    //# toggle hover lines in charts, main and compare chart
                    this.subscriptionLoadSummaryLineData = this.dataExchange.chartLoadSummaryLineDataCurrent.subscribe((r: LoadingSummaryLineDataGUID) =>
                        this.helper.tryCatch(() => {
                            if (r && r.GUID === this.sharedGUID){
                                this.selectChart(r);
                                this.updateCursor();
                            }
                        })
                    );

                    /**
                     * Calculate aggregation for charts
                     */
                    this.subscriptionCalcAgg = this.dataExchange.chartAggCurrent.subscribe((r: RangeAggGUID) =>
                        this.helper.tryCatch(() => {
                            if (r && r.GUID === this.sharedGUID){
                                this.calcAgg(r.range, r.isMainChart);
                            }
                        })
                    );

                    /**
                     * Calculate chart dimensions on position change
                     */
                    this.subscriptionUpdateChartDimensions = this.dataExchange.updateChartDimensionsCurrent.subscribe((r: string) =>
                        this.helper.tryCatch(() => r && r === this.sharedGUID && this.calcChartsDimensions())
                    );

                    //# if Height too small hide bubble chart, or get property from localStorage
                    this.helper.wait(() => {
                        let bubbleVisibleLocal = localStorage[this.type + 'bubbleVisible'];
                        if (typeof bubbleVisibleLocal === 'undefined' && document.body.offsetHeight < 650){
                            this._bubbleVisible = false;
                        } else if (typeof bubbleVisibleLocal === 'undefined'){
                            this._bubbleVisible = true;
                        } else{
                            this._bubbleVisible = (bubbleVisibleLocal === 'true');
                        }

                        this.dataExchange.setToggleBubbleChart({
                            type: this.type,
                            sharedGUID: this.sharedGUID,
                            show: this.bubbleVisible
                        });
                    });

                    // $(`#${this.id} [data-toggle="tooltip"]`).tooltip({trigger: 'hover', offset: "50px, 0", template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'})

                    // this.comparePopperAdd();
                }

            }, 100)

            this.chartWrpWidth = this.mainWrapperRef.nativeElement.offsetWidth;

            //this.generateGraph();
            //this.generateBubbleChart2();
        });


    }

    ngOnDestroy(){
        this.zone.runOutsideAngular(() => {
            if (this.chart){
                this.chart.dispose();
            }

            if (this.bubbleChart){
                this.bubbleChart.dispose();
            }

            if (this.summaryLineChart){
                this.summaryLineChart.dispose();
            }

            if (this.axisChart){
                this.axisChart.dispose();
            }
        });

        this.subscriptionShowTargetLevel.unsubscribe();
        this.subscriptionUpdateChartData.unsubscribe();
        this.subscriptionToggleBubbleChart.unsubscribe();
        this.subscriptionToggleChartInfo.unsubscribe();
        this.subscriptionUpdateChartZoom.unsubscribe();
        this.subscriptionUpdateCustomChartPopper.unsubscribe();
        this.subscriptionUpdateLineVisibility.unsubscribe();
        this.subscriptionCalcAgg.unsubscribe();
        this.subscriptionSetHover.unsubscribe();
        this.subscriptionUpdateChartDimensions.unsubscribe();
        this.subscriptionLoadSummaryLineData.unsubscribe();
        this.subscriptionSetGlass.unsubscribe();
        this.subscriptionCompareChartReady.unsubscribe();

        this.removeFromListProps();
        this.removeFromListProps(this.addItemGUID);
        this.compareButtonsPopper ? this.compareButtonsPopper.destroy() : null;

        this.chart = null;
        this.bubbleChart = null;
        this.lines = null;
        this.bubbleLines = null;

        // this.listenResize();
    }

    ngAfterViewChecked(){
        if (this.customListsPopperCreate){
            this.customListsPopperCreate = false;
            this.popperAdd();
        }

        if (this.compareButtonsPopperUpdate){
            this.compareButtonsPopperUpdate = false;
            this.compareButtonsPopper ? this.compareButtonsPopper.update() : null;
        }

    }

    /**
     * Set chart wrapper width
     * @param val - width
     */
    public set chartWrpWidth(val: number){
        this.helper.wait(() => this._chartWrpWidth = val);
    };

    /**
     * Get chart wrapper width
     */
    public get chartWrpWidth(): number{
        return this._chartWrpWidth
    }

    public set bubbleVisible(val: boolean){
        if (this._bubbleVisible !== val){
            this._bubbleVisible = val;
            localStorage[this.type + 'bubbleVisible'] = val;
        }
    }

    public get bubbleVisible(): boolean{
        return this._bubbleVisible
    }

    public get chartType(): typeof BGChartType{
        return BGChartType;
    }

    //# update and sort legends for line and bubble chart
    /*private updateLegends = (): void => {
        this.info = this.chartLines.filter(item => item);
        this.info.sort(function (a: ChartLineModel, b: ChartLineModel){
            return a.position - b.position;
        });

        // let idx = this.info.findIndex(item => item.name === 'bufferG');
        //
        // if (idx > -1){
        //
        //     let item = this.info.splice(idx, 1);
        //     this.info.unshift(item[0])
        // }

        this.infoBubble = this.bubbleChartLines.filter(item => !item.hideLineInLegend);
        this.infoBubble.sort(function (a: ChartLineModel, b: ChartLineModel){
            return a.position - b.position;
        });
    };*/

    //# update line visibility for line chart
    private updateChartLines = (info: ChartLineModel[]): void => {
        info.forEach(item => {
            item.enabled ? this.lines[item.name].show() : this.lines[item.name].hide();
        });
    };

    //# update line visibility for line chart
    private updateBubbleChartLines = (infoBubble: ChartLineModel[]): void => {
        infoBubble.forEach(item => {
            item.enabled ? this.bubbleLines[item.name].show() : this.bubbleLines[item.name].hide();
        });
    };

    //# update list of warehouses where this SKU presents and itemId of this SKU on central warehouse
    private updateCWHItemId = (): void => {
        if (!this.isMainChart){
            return;
        }

        this.graphService.getCompareData(this.itemId).subscribe(data => {
            if (data == null || data.accessDenied)
                return;

            this.cwhItemId = data.cwhItemId;
            this.compareItems = data.items;
        });
    };

    //# create filter for custom add chart form
    private addToListProps = (GUID?: string): void => {
        let chartListProps: ChartListProps[] = this.dataExchange.getChartListProps(),
            filter = new StocksFilter();
        if (!GUID){
            filter.skus = [this.chartData.itemInfo.sku];
            filter.warehouses = [this.chartData.itemInfo.warehouseCode];
        }

        chartListProps.push(new ChartListProps(GUID ? GUID : this.GUID, filter));
        this.dataExchange.setChartListProps(chartListProps);
    };

    //# remove filter for custom add chart form
    //TODO move this function to buffer-graph component
    private removeFromListProps = (GUID?: string): void => {
        let chartListProps: ChartListProps[] = this.dataExchange.getChartListProps(),
            idx = chartListProps.findIndex(item => item.GUID === (GUID ? GUID : this.GUID));

        if (idx > -1){
            chartListProps.splice(idx, 1);
            this.dataExchange.setChartListProps(chartListProps);
        }
    };

    //# generate line chart
    private generateGraph = (): void => {
        am4core.useTheme(am4themes_animated);
        this.chart = am4core.create(this.GUID, am4charts.XYChart);
        this.chart.resizable = true;
        //# set data
        this.chart.data = this.chartData.rows;


        this.chart.padding(15, 0, 0, 10);

        //# set locale
        this.chart.language.locale = this.getChartLocale(this.translateService.currentLang);

        //# Create axes
        this.chartXAxis = this.chart.xAxes.push(new am4charts.DateAxis());
        this.hideAxis(this.chartXAxis);

        this.chartYAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
        this.chartYAxis.renderer.minGridDistance = 30;
        this.chartXAxis.renderer.axisFills.interactionsEnabled = true;
        this.chartYAxis.renderer.axisFills.interactionsEnabled = true;

        const genSecondYAxis = (name: string, color: string): void => {
            this[name] = this.chart.yAxes.push(new am4charts.ValueAxis());
            this[name].renderer.axisFills.interactionsEnabled = true;
            this[name].renderer.opposite = true;
            this[name].renderer.labels.template.fill = am4core.color(color);
            this[name].renderer.grid.template.strokeOpacity = 1;
            this[name].renderer.grid.template.stroke = am4core.color(color);
            this[name].renderer.grid.template.strokeWidth = 1;
            this[name].renderer.labels.template.verticalCenter = "middle";
            this[name].renderer.labels.template.horizontalCenter = "left";
            this[name].min = 0;
            this[name].disabled = true
        }

        genSecondYAxis('chartYAxisRepTime', '#e3000f');
        genSecondYAxis('chartYAxisLifeTime', '#0026e3');
        genSecondYAxis('chartYAxisBalanceAm', '#e39b00');

        // this['chartYAxisBalanceAm'].start = 0;
        // this['chartYAxisBalanceAm'].end = 1;

        this.chartYAxis.keepSelection = true;

        //# set date display format for chart
        this.setDatesDisplayProps(this.chart, this.chartXAxis);

        //# change zoom on other charts
        const dateAxisChanged = (ev) => {
            let start = new Date(ev.target.minZoomed),
                end = new Date(ev.target.maxZoomed);
            this.chart.cursor.selection.hide();

            this.savedZoom = {start, end};
            // this.chartXAxis.zoomToDates(start, end);
            this.bubbleChartXAxis.zoomToDates(start, end);
            this.axisChartXAxis.zoomToDates(start, end);
            this.type === BGChartType.Summary && this.summaryLineChartXAxis.zoomToDates(start, end);
            this.zoomStartDate = start;
            this.zoomEndDate = end;
            let startFull: boolean = this.chartData.startDate.isSame(
                    moment(start).subtract(new Date(start).getTimezoneOffset(), 'minutes'), 'day'),
                endFull: boolean = this.chartData.endDate.isSame(end, 'day');

            this.dataExchange.setUpdateChartZoom({
                type: this.type,
                sharedGUID: this.sharedGUID,
                start: start,
                end: end,
                startFull: startFull,
                endFull: endFull
            })
            // }

        };

        if (!this.isMainChart){
            this.chart.zoomOutButton.disabled = true;
        }

        if (this.isMainChart){
            this.chartXAxis.events.on("startchanged", dateAxisChanged);
            this.chartXAxis.events.on("endchanged", dateAxisChanged);
        }

        //# add lines to line chart
        this.chartLines.forEach((item, i) => {
            this.addLineWithOptions(item.name, item.color, item.areaFilledOnLine,
                item.showBulletOnLine, item.hideLineInLegend, item.showLineByDefault,
                item.lineName, i);
        });

        //# custom logic for some lines toggling visibility
        this.lines.valueOut.events.on("shown", () => {
            this.lines.qntOut1.hide();
            this.disableLegend('qntOut1');
            this.lines.qntOut2.hide();
            this.disableLegend('qntOut2');
            this.lines.discountQnt.hide();
            this.disableLegend('discountQnt');
        });

        this.lines.qntOut1.events.on("shown", () => {
            this.lines.valueOut.hide();
            this.disableLegend('valueOut');
        });

        this.lines.qntOut2.events.on("shown", () => {
            this.lines.valueOut.hide();
            this.disableLegend('valueOut');
        });

        this.lines.discountQnt.events.on("shown", () => {
            this.lines.valueOut.hide();
            this.disableLegend('valueOut');
        });

        // this.addCursor();
        this.chart.legend = new am4charts.Legend();

        //# container for legends
        const resizeLegend = (): void => {
            document.getElementById('legenddiv-' + this.GUID).style.height = this.chart.legend.contentHeight + "px";
        };

        let legendContainer = am4core.create('legenddiv-' + this.GUID, am4core.Container);
        legendContainer.width = am4core.percent(100);
        legendContainer.height = am4core.percent(100);
        this.chart.legend.parent = legendContainer;

        this.chart.events.on("appeared", resizeLegend);
        this.chart.events.on("sizechanged", () => {resizeLegend(); this.updateCursor()});

        this.chart.legend.useDefaultMarker = true;

        let marker = this.chart.legend.markers.template.children.getIndex(0);
        marker.adapter.add("fill", this.legendColors);

        //# Set up number format
        this.chart.numberFormatter.numberFormat = "#,###.00";

        //# initiate chart
        this.chart.events.on("ready", () => {
            this.chartReady = true;
            document.getElementById('legenddiv-' + this.GUID).style.height = this.chart.legend.contentHeight + "px";
            this.chartLines.forEach(item => {
                if (!item.showLineByDefault){
                    this.lines[item.name].show();
                    this.lines[item.name].hide();
                }
            });

            this.dataExchange.updateStaticPopup(new UpdateStaticPopupGUID(this.sharedGUID, this.isMainChart));
            let range = this.dataExchange.getAggRange(this.sharedGUID);
            this.calcAgg(range && range.range ? range.range : null)
            if (!this.isMainChart){
                let lines = this.dataExchange.getChartLinesData(this.sharedGUID);
                if (lines){
                    this.updateChartLines(lines.chartLines);
                }
                // this.dataExchange.setCompareChartReady({
                //     command: 'ready',
                //     type: this.type,
                //     sharedGUID: this.sharedGUID,
                //     lines: null
                // })
            }


            // this.commonData.showLoadingImg = false;
        });

        //# After validated update zoom for charts
        this.chart.events.on("validated", () => {
            if (this.chartReady){
                // this.savedZoom && console.log(
                //     this.chartData.startDate.isSameOrBefore(moment(this.savedZoom.start)),
                //     this.chartData.endDate.add(1, 'days').isSameOrAfter(moment(this.savedZoom.end)),
                //     this.chartData.endDate.add(1, 'days'), moment(this.savedZoom.end),'zoom to dates')
                if (this.savedZoom && (this.chartData.startDate.isSameOrBefore(moment(this.savedZoom.start)) &&
                    this.chartData.endDate.clone().add(1, 'days').isSameOrAfter(moment(this.savedZoom.end)))){

                    this.chartXAxis.zoomToDates(this.savedZoom.start, this.savedZoom.end);
                    this.bubbleChartXAxis.zoomToDates(this.savedZoom.start, this.savedZoom.end);
                    this.axisChartXAxis.zoomToDates(this.savedZoom.start, this.savedZoom.end);
                    this.type === BGChartType.Summary && this.summaryLineChartXAxis.zoomToDates(this.savedZoom.start, this.savedZoom.end);
                    this.helper.wait(() => this.calcAgg(null), 15);
                } else{
                    this.helper.wait(() => {
                        let savedRange = this.dataExchange.getAggRange(this.sharedGUID);
                        this.calcAgg(savedRange && savedRange.range ? savedRange.range : null );
                    }, 15);

                }
                this.helper.wait(() => {
                    let lines = this.dataExchange.getChartLinesData(this.sharedGUID);
                    if (lines){
                        this.updateChartLines(lines.chartLines);
                    }

                    this.dataExchange.updateStaticPopup(new UpdateStaticPopupGUID(this.sharedGUID, this.isMainChart));

                }, 10)
            }
        });

        // zoom scrollbar
        if (this.isMainChart){
            this.chart.scrollbarX = new am4charts.XYChartScrollbar();

            this.chart.scrollbarX.series.push(this.lines.actionBuffer);
            let scrollContainer = am4core.create('scrollbar-' + this.GUID, am4core.Container);
            scrollContainer.width = am4core.percent(95);
            scrollContainer.align = 'center';
            this.chart.scrollbarX.parent = scrollContainer;
            this.chart.scrollbarX.thumb.width = 100;

            // set locales
            this.chart.scrollbarX.language.locale = this.getChartLocale(this.translateService.currentLang);
        }

        // scrollbar
        this.chart.scrollbarY = new am4core.Scrollbar();
        this.chart.scrollbarY.background.fill = am4core.color("lightgrey");
        this.chart.scrollbarY.endGrip.background.fill = am4core.color("lightgrey");
        this.chart.scrollbarY.startGrip.background.fill = am4core.color("lightgrey");
        this.chart.scrollbarY.thumb.background.fill = am4core.color("lightgrey");
        this.chart.scrollbarY.stroke = am4core.color("lightgrey");

        this.chart.legend.itemContainers.template.events.on("hit", () => {
            // let lbl = this.chart.map.getKey(ev.target.dataItem.dataContext.dataFields.valueY);
        });
        this.addMainChartCursor();
    };

    /**
     * Get Localization for charts
     * @param locale - short language
     */
    private readonly getChartLocale = (locale: string): any => {
        switch (locale){
            case 'uk': return am4lang_uk_UA;
            case 'en': return am4lang_en;
            case 'lt': return am4lang_lt_LT;
            case 'pl': return am4lang_pl_PL;
            case 'ru': return am4lang_ru_RU;
            default: return am4lang_en;
        }
    }

    /**
     * Hide current axis
     * @param axis
     */
    private hideAxis = (axis: any): void => {
        axis.renderer.labels.template.fill = am4core.color("rgba(255, 255, 255, 0.0)");
        axis.renderer.grid.template.strokeOpacity = 0;
        axis.renderer.grid.template.stroke = am4core.color("rgba(255, 255, 255, 0.0)");
        axis.renderer.grid.template.strokeWidth = 0;
        this.hideAxisTooltip(axis);
    }

    /**
     * Add cursor for main chart
     */
    private addMainChartCursor = (): void => {
        if (!this.chart) return;
        //# cursor and legend
        this.chart.cursor = new am4charts.XYCursor();
        this.chart.cursor.behavior = "selectX";

        //# Show overal close values when cursor is not shown
        this.chart.cursor.events.on("hidden", () => {
            if (!this.freezeDataChange){
                this.dataExchange.updateStaticPopup(new UpdateStaticPopupGUID(this.sharedGUID, this.isMainChart))
            }
        });

        //# Set up cursor's events to update the label
        this.chart.cursor.events.on("cursorpositionchanged", (ev) => {
            if (!this.freezeDataChange){
                this.dataExchange.updateStaticPopup(new UpdateStaticPopupGUID(this.sharedGUID, this.isMainChart, this.chartXAxis))
            }
            if (this.blockMainChartCursor){
                this.blockMainChartCursor = false;
                return;
            }
            this.setCursorToChart(ev,  'main');
        });

        this.chart.cursor.events.on("selectended", (ev) => {
            if (ev.target.xRange){
                this.dataExchange.setAggRange(new RangeAggGUID(this.sharedGUID, ev.target.xRange))
                // this.savedRange = ev.target.xRange;
            } else{
                this.dataExchange.setAggRange(new RangeAggGUID(this.sharedGUID, null))
                //this.savedRange = null;
                if (this.CTRLPressed){
                    this.freezeDataChange = !this.freezeDataChange
                    this.dataExchange.updateInfoParam(new UpdateInfoParamGUID(this.sharedGUID, 'freezeDataChange', this.freezeDataChange))
                }
            }

            let subsRange = this.dataExchange.getAggRange(this.sharedGUID);
            subsRange.isMainChart = this.isMainChart;
            this.dataExchange.calcAgg(subsRange);
            // this.chart.cursor.selection.hide();
            // this.helper.wait(() => this.chart.cursor.selection.show(), 500)

            // this.helper.wait(this.updateCursor, 500)

            // this.helper.wait(() => this.chart.cursor && (this.chart.cursor.behavior = ''), 100)
            // this.helper.wait(() => this.chart.cursor && (this.chart.cursor.behavior = "selectX"), 200)

            // this.calcAgg(this.savedRange);

        });

        this.chart.cursor.events.on("selectstarted", (ev) => {
            // this.updateCursor();
            // this.chart.cursor.selection.hide();
            // this.chart.cursor.selection.show();
        });


    }

    /**
     * sync cursor for all charts
     * @param ev - chart event
     * @param chartName
     */
    private readonly setCursorToChart = (ev: any, chartName: string): void => {
        let xAxis = ev.target.chart.xAxes.getIndex(0),
            date = xAxis.positionToDate(xAxis.toAxisPosition(ev.target.xPosition)),
            pointMainChart, pointBubbleChart, pointLineChart, pointAxisChart;

        const setCursorToMainChart = (): void => {
                // console.log('setCursorToMainChart')
                this.blockMainChartCursor = true;
                pointMainChart = this.chartXAxis.dateToPoint(date);
                this.chart.cursor && this.chart.cursor.triggerMove(pointMainChart, "soft");
        }

        const setCursorToBubbleChart = (): void => {
                // console.log('setCursorToBubbleChart')
                this.blockBubbleChartCursor = true;
                pointBubbleChart = this.bubbleChartXAxis.dateToPoint(date);
                this.bubbleChart.cursor && this.bubbleChart.cursor.triggerMove(pointBubbleChart, "soft");
        }

        const setCursorToSummaryLineChart = (): void => {
            if (this.type === BGChartType.Summary){
                // console.log('setCursorToSummaryLineChart')
                this.blockSummaryLineChartCursor = true;
                pointLineChart = this.summaryLineChartXAxis.dateToPoint(date);
                this.summaryLineChart.cursor && this.summaryLineChart.cursor.triggerMove(pointLineChart, "soft");
            }
        }

        const setCursorAxisChart = (): void => {
            // console.log('setCursorAxisChart')
            pointAxisChart = this.axisChartXAxis.dateToPoint(date);
            this.axisChart.cursor.triggerMove(pointAxisChart, "soft");
        }

        if (this.cursorTimeout){
            clearTimeout(this.cursorTimeout);
            this.cursorTimeout = null;
        }

        this.cursorTimeout = setTimeout(() => {
            clearTimeout(this.cursorTimeout);
            this.cursorTimeout = null;
            switch (chartName){
                case 'main':
                    setCursorToBubbleChart();
                    setCursorToSummaryLineChart();
                    break;
                case 'bubble':
                    setCursorToMainChart();
                    setCursorToSummaryLineChart();
                    break;
                case 'summaryLine':
                    setCursorToMainChart();
                    setCursorToBubbleChart();
                    break;
            }
            setCursorAxisChart();

        }, 50)


    }

    //# update zoom
    private updateZoom = (start: Date, end: Date): void => {
        if (!this.isMainChart){
            this.chartXAxis.zoomToDates(start, end);
            this.bubbleChartXAxis.zoomToDates(start, end);
            this.axisChartXAxis.zoomToDates(start, end);
            this.type === BGChartType.Summary && this.summaryLineChartXAxis.zoomToDates(start, end);
            this.zoomStartDate = start;
            this.zoomEndDate = end;
        }
    };

    /**
     * Calculate aggregation
     * @param range - for calculate
     * @param isMainChart
     */
    private readonly calcAgg = (range?: any, isMainChart: boolean = null): void => {
        this.bufferAgg(range);
        this.salesAgg(range);
        if (isMainChart !== null && this.isMainChart !== isMainChart){
            console.log('calcAgg')
            this.chart.cursor.selection.hide();
        }
        this.dataExchange.setChartAggregations(new UpdateChartAggGUID(this.sharedGUID, this.agg, this.isMainChart, this.aggPeriod));
    }

    //# generate aggregation for buffer
    private bufferAgg = (range?): void => {
        this.agg = [];
        let dates: ChartAggDatesModel = this.getRangeDates(range),
            data: ChartAggDataBuffer = this.getDataBufferAgg(dates, range);
        dates = this.checkRangeDates(dates, data.cnt);
        this.updateBufferAgg(dates.period, data.avg, data.max, data.min);
    };

    //# generate aggregation for sales
    private salesAgg = (range?): void => {
        let dates: ChartAggDatesModel = this.getRangeDates(range),
            data: ChartAggDataSales = this.getDataSalesAgg(dates, range);
        dates = this.checkRangeDates(dates, data.cnt);
        this.updateSalesAgg(dates.period, data);
    };

    //# set colors for legend (no use)
    private legendColors = (adapter: string, target, defColor: string = '#000000'): any => {
        if (!target.dataItem){
            return defColor;
        }
        let settings = target.dataItem.dataContext.dummyData;
        return settings && settings.color !== undefined ? am4core.color(settings.color) : am4core.color(defColor);
    };

    //# get dates range after selection range on line chart
    private getRangeDates = (range?: any): ChartAggDatesModel => {
        let from, to;
        if (range){
            let axis = this.chartXAxis;

            from = axis.positionToDate(axis.toAxisPosition(range.start));

            to = axis.positionToDate(axis.toAxisPosition(range.end));
            let endDateToday = moment(to).format(this.helper.getLocale(this.translateService.currentLang)) === this.chartData.todayDate.format(this.helper.getLocale(this.translateService.currentLang));
            let endDateAfter = moment(to).startOf('day').isAfter(this.chartData.todayDate.startOf('day'));
            if (endDateToday || endDateAfter){
                let date = new Date(to);
                let days: number = endDateToday ? 1 : 2;

                date.setDate(to.getDate() - days);
                to = date;
            }
        } else{
            from = moment(this.chartData.startDate).toDate();
            let endDateToday = this.chartData.endDate.startOf('day').isSame(this.chartData.todayDate.startOf('day'));
            to = endDateToday ? moment(this.chartData.endDate.clone().subtract(1, "days")).toDate() : moment(this.chartData.endDate).toDate();
        }

        let shortLocale = this.helper.getShortLocale(this.translateService.currentLang);
        let period = moment(from).format(shortLocale) + " - " + moment(to).format(shortLocale);
        return new ChartAggDatesModel(period, from, to);
    };

    //# check dates range
    private checkRangeDates = (dates: ChartAggDatesModel, cnt: number): ChartAggDatesModel => {
        if (cnt === 1){
            dates.period = dates.to.toLocaleDateString("ru-ru") + " - " + dates.to.toLocaleDateString("ru-ru");
        }
        return dates;
    };


    //# generate data for sales aggregation
    private getDataSalesAgg = (dates: ChartAggDatesModel, range?): ChartAggDataSales => {
        let sumSales: number = 0, days: number = 0, avg: number, min = 9999999, max = -9999999, cnt: number = 0,
            sumOther: number = 0, simDiscountSales: number = 0,
            dataset = this.lines.actionBuffer.dataItems.values;
        let from = this.helper.removeTime(dates.from),
            to = this.helper.removeTime(dates.to);
        const maxMin = (i: number): void => {
            if (dataset[i].dataContext.qntOut1 > max) max = dataset[i].dataContext.qntOut1;
            if (dataset[i].dataContext.qntOut1 < min) min = dataset[i].dataContext.qntOut1;
        };

        const sales = (i: number): void => {
            if (dataset[i].dataContext.qntOut1 == null){
                dataset[i].dataContext.qntOut1 = 0;
            }

            sumSales += dataset[i].dataContext.qntOut1;
            sumOther += dataset[i].dataContext.qntOut2;
            simDiscountSales += dataset[i].dataContext.discountQnt;
        }

        for (let i = 0; i < dataset.length; i++){
            if (range){
                if (dataset[i].dateX >= from && dataset[i].dateX <= to){
                    if (dataset[i].dataContext.balance > 0 || dataset[i].dataContext.valueOut > 0){
                        sales(i);
                        maxMin(i);
                        days++;
                    }
                    cnt++;
                }
            } else{
                if (dataset[i].dataContext.balance > 0 || dataset[i].dataContext.valueOut > 0){
                    days++;
                    sales(i);
                    maxMin(i);
                }
                cnt++;
            }
        }


        avg = (sumSales / cnt);
        min = min === null || min === 9999999 ? 0 : min;
        max = max === null || max === -9999999 ? 0 : max;
        avg = isNaN(avg) ? 0 : avg;
        sumSales = isNaN(sumSales) || sumSales === null ? 0 : sumSales;
        sumOther = isNaN(sumOther) || sumOther === null ? 0 : sumOther;
        simDiscountSales = isNaN(simDiscountSales) || simDiscountSales === null ? 0 : simDiscountSales;

        return new ChartAggDataSales(sumSales, simDiscountSales, sumOther, avg, max, min, cnt, days, cnt - days);
    };

    //# generate data for buffer aggregation
    private getDataBufferAgg = (dates: ChartAggDatesModel, range?): ChartAggDataBuffer => {
        let dataset = this.lines.actionBuffer.dataItems.values,
            sum: number = 0, avg: number, min: number = 9999999, max: number = -9999999, cnt = 0;
        let from = this.helper.removeTime(dates.from),
            to = this.helper.removeTime(dates.to);

        const maxMin = (i: number): void => {
            if (dataset[i].dataContext.actionBuffer > max) max = dataset[i].dataContext.actionBuffer;
            if (dataset[i].dataContext.actionBuffer < min) min = dataset[i].dataContext.actionBuffer;
        }

        for (let i = 0; i < dataset.length; i++){
            if (range){
                if (dataset[i].dateX >= from && dataset[i].dateX <= to){
                    cnt++;
                    sum += dataset[i].dataContext.actionBuffer;
                    maxMin(i);
                }
            } else{
                cnt++;
                sum += dataset[i].dataContext.actionBuffer;
                maxMin(i);
            }
        }

        avg = (sum / cnt);

        min = min === null || min === 9999999 ? 0 : min;
        max = max === null || max === -9999999 ? 0 : max;
        avg = isNaN(avg) ? 0 : avg;
        //sum = isNaN(sum) || sum === null ? 0 : sum;

        return new ChartAggDataBuffer(avg, min, max, cnt)
    };

    //# set data for sales aggregations
    private updateSalesAgg = (period: string, data: ChartAggDataSales): void => {
        // this.aggPeriod = period;
        this.agg.push(new ChartAggModel('Sales', 'SUM', data.sumSales.toFixed(4).toString()));
        this.agg.push(new ChartAggModel('MainChart_DiscountQnt', 'SUM', data.sumDiscountSales.toFixed(4).toString()));
        this.agg.push(new ChartAggModel('MainChart_QntOut2', 'SUM', data.sumOther.toFixed(4).toString()));
        this.agg.push(new ChartAggModel('Sale', 'AVG', data.avg.toFixed(4)));
        this.agg.push(new ChartAggModel('Sale', 'MIN', data.min.toString()));
        this.agg.push(new ChartAggModel('Sale', 'MAX', data.max.toString()));
        this.agg.push(new ChartAggModel('Chart_DaysSale', '', data.withSales.toString()));
        this.agg.push(new ChartAggModel('Chart_DaysWithoutSale', '', data.withoutSales.toString()));
    };

    //# set data for buffer aggregations
    private updateBufferAgg = (period: string, avg: number, max: number, min: number): void => {
        this.aggPeriod = period;
        this.agg.push(new ChartAggModel('Buffer', 'AVG', avg.toFixed(4)));
        this.agg.push(new ChartAggModel('Buffer', 'MIN', min.toString()));
        this.agg.push(new ChartAggModel('Buffer', 'MAX', max.toString()));
    };

    //# add line for line chart
    private addLineWithOptions = (name: string, color: string, isFilled: boolean, showBullet: boolean, defaultColumn: boolean, defaultVisibility: boolean, displayName: string, idx: number): void => {

        if (name === 'cancellation'){
            // console.log(name, displayName, 'addLineWithOptions')
            let colorRGB = this.helper.hexColorToRGB(color),
                colorRGBText = `rgba(${colorRGB[0]},${colorRGB[1]},${colorRGB[2]},0.5)`,
                colorRGB2 = `rgba(${colorRGB[0]},${colorRGB[1]},${colorRGB[2]},0.8)`;

            this.lines[name] = this.chart.series.push(new am4charts.ColumnSeries());
            this.lines[name].showOnInit = false;
            this.lines[name].hiddenState.transitionDuration = 0;
            this.lines[name].defaultState.transitionDuration = 0;
            // this.lines[name].interpolationDuration  = 0;
            this.lines[name].dataFields.valueY = name;
            this.lines[name].dataFields.dateX = "date";
            this.lines[name].name = displayName;
            this.lines[name].stroke = am4core.color(colorRGBText);
            this.lines[name].fill = am4core.color(colorRGBText);
            this.lines[name].tooltip.pointerOrientation = 'vertical';
            // this.lines[name].columns.template.tooltipText = `${displayName}: {valueY}`;
            // this.lines[name].tooltipText = `${displayName}: {valueY}`;
            this.lines[name].tooltip.getFillFromObject = false;
            this.lines[name].tooltip.background.fill = am4core.color(color);

            let columnTemplate = this.lines[name].columns.template;
            columnTemplate.interactionsEnabled = true;

            let hs = columnTemplate.states.create("hover");
            // console.log(this.lines[name].columns, 'this.lines[name].columns')
            // hs.properties.stroke = am4core.color(colorRGB2);
            hs.properties.fill = am4core.color(colorRGB2);

            if (!defaultVisibility){
                this.lines[name].visible = false;
                this.lines[name].hidden = true;
            }

            this.lines[name].events.on('over', () => this.lines[name].tooltipText = `${displayName}: {valueY}`);
            this.lines[name].events.on('out', () => this.lines[name].tooltipText = '');

            this.lines[name].dummyData = {
                color: colorRGBText,
                name: name
            };

        } else {
            this.lines[name] = this.chart.series.push(new am4charts.LineSeries());
            this.lines[name].showOnInit = false;
            this.lines[name].dataFields.buffer = 'bufferGBT';
            this.lines[name].dataFields.actionBufferABT = 'bufferABT';
            this.lines[name].dataFields.valueY = name;
            this.lines[name].dataFields.dateX = "date";
            this.lines[name].strokeWidth = 2;
            this.lines[name].name = displayName;
            this.lines[name].stroke = am4core.color(color);
            this.lines[name].fill = am4core.color(color);
            this.lines[name].minBulletDistance = 10;
            this.lines[name].hiddenInLegend = defaultColumn;
            this.lines[name].defaultState.transitionDuration = 0;
            this.lines[name].hiddenState.transitionDuration = 0;
            this.lines[name].cursorTooltipEnabled = false;

            // this.lines[name].events.on("ready", function(ev) {
            //     ev.target.tooltip.zIndex = 1000;
            // });

            if (name === 'replenishmentTime'){
                this.lines[name].yAxis = this.chartYAxisRepTime;
                this.chartYAxisRepTime.disabled = !defaultVisibility;
            }

            if (name === 'lifeTime'){
                this.lines[name].yAxis = this.chartYAxisLifeTime;
                this.chartYAxisLifeTime.disabled = !defaultVisibility;
            }

            if (name === 'balanceAmount' || name === 'saleAmount'){
                this.lines[name].yAxis = this.chartYAxisBalanceAm;
                this.chartYAxisBalanceAm.disabled = !defaultVisibility;
            }

            this.lines[name].dummyData = {
                color: color,
                name: name
            };

            if (isFilled){
                this.lines[name].strokeWidth = 0;
                this.lines[name].fillOpacity = 1;
                this.lines[name].fill = am4core.color(color);
            }

            if (showBullet){
                this.lines[name + "bullet"] = this.lines[name].bullets.push(new am4charts.CircleBullet());
                this.lines[name + "bullet"].circle.strokeWidth = 0;
                this.lines[name + "bullet"].circle.radius = 6;
                this.lines[name + "bullet"].circle.fill = am4core.color('rgba(0,0,0,0)');
                this.lines[name + "bullet"].events.on("ready", function(ev) {
                    ev.target.tooltip.zIndex = 1000;
                });



                if (name === 'actionBuffer'){
                    this.lines[name + "bullet"].fill = am4core.color("#7FC07F");
                    this.lines[name + "bullet"].tooltipText = `${displayName}: {actionBufferABT}`;
                } else if (name === 'bufferG'){
                    this.lines[name + "bullet"].tooltipText = `${displayName}: {buffer}`;
                } else if (name === 'actionSafetyBuffer'){
                    this.lines[name + "bullet"].fill = am4core.color("#B22222");
                    this.lines[name + "bullet"].tooltipText = `${displayName}: {valueY}`;
                } else{
                    this.lines[name + "bullet"].tooltipText = `${displayName}: {valueY}`;
                }
                this.lines[name + "bullet"].zIndex = 1000;

                let segment = this.lines[name].segments.template;
                segment.interactionsEnabled = true;

                let hs = segment.states.create("hover");
                hs.properties.strokeWidth = 3;

                this.lines[name + "bullet"].events.on("hit", () => {
                    // this.savePDF();
                })

                //this.lines[name + "bullet"].events.on("click", (event) => {
                //  this.lines[name + "bullet"].tooltipText = "This is something else";
                //});
                let bullethover = this.lines[name + "bullet"].states.create("hover");
                bullethover.properties.scale = 1.3;

                this.lines[name + 'innerCircle'] = this.lines[name + "bullet"].createChild(am4core.Circle);
                this.lines[name + 'innerCircle'].verticalCenter = "middle";
                this.lines[name + 'innerCircle'].horizontalCenter = "middle";

                this.lines[name + 'innerCircle'].radius = 2.5;

                let bulletColor: string;

                switch (name){
                    case 'actionBuffer':
                        bulletColor = '#7FC07F';
                        break;
                    case 'actionSafetyBuffer':
                        bulletColor = '#B22222';
                        break;
                    default:
                        bulletColor = color;
                        break;
                }

                this.lines[name + 'innerCircle'].fill = am4core.color(bulletColor);

                this.lines[name + 'innerCircle'].strokeWidth = 0;

                let innerCircleHover = this.lines[name + 'innerCircle'].states.create("hover");
                innerCircleHover.properties.scale = 1.3;

                // set black border for buffer line when no data
                if (name === 'actionBuffer'){
                    this.lines[name + "innerCircle"].stroke = am4core.color('#000000');
                    this.lines[name].dataFields.value = "noDataBool";

                    this.lines[name].heatRules.push({
                        target: this.lines[name + "innerCircle"],
                        minValue: 0,
                        maxValue: 1,
                        min: 0,
                        max: 1,
                        property: "strokeWidth",
                        dataField: "value"
                    });

                    this.lines[name].heatRules.push({
                        target: this.lines[name + "innerCircle"],
                        minValue: 0,
                        maxValue: 1,
                        min: 2.5,
                        max: 3,
                        property: "radius",
                        dataField: "value"
                    });
                }

                // this.lines[name + "event"] = this.lines[name + "bullet"].events.on("rollOverGraphItem", function (ev) {
                // }, this);
            }
            if (!defaultVisibility){
                // this.lines[name].hide();
                this.lines[name].visible = false;
                this.lines[name].hidden = true;
            } else {
                // this.lines[name].show();
            }

            this.lines[name].events.on("shown", () => {
                this.dataExchange.updateStaticPopup(new UpdateStaticPopupGUID(this.sharedGUID, this.isMainChart))
                // this.updateStaticPopup();
            });

            this.lines[name].events.on("hidden", () => {
                this.dataExchange.updateStaticPopup(new UpdateStaticPopupGUID(this.sharedGUID, this.isMainChart))
                // this.updateStaticPopup();
            });
        }

    };

    //# send message to service for update line visibility for line chart in main and compare chart
    public toggleShowLines = (lineName: string, chartType: string): void => {
        this.dataExchange.setToggleLinesVisibility({
            type: this.type,
            sharedGUID: this.sharedGUID,
            lineName: lineName,
            chart: chartType
        });
    };

    //# send message to service for update line visibility for line chart in main and compare chart
    public selectChart = (item: LoadingSummaryLineDataGUID): void => {
        if (this.loadingSummaryLineData || item.loadEnd){
            return;
        }

        if (item.line.summaryLineSelected){
            this.summaryLineSelected = null;
            this.calcChartsDimensions()
        } else{
            this.summaryLineSelected = item.line;
            this.loadingSummaryLineData = true;
            this.graphService.getSummaryChartLineData(item.line.name, this.chartData.startDate, this.chartData.endDate).subscribe(r => {
                if (!r || !r.success){
                    console.error(r);
                } else{
                    this.summaryLineChart.data = r.result;

                    this.linesChartLine['idsCount'].stroke = am4core.color(item.line.color);
                    this.linesChartLine['idsCount'].fill = am4core.color(item.line.color);

                    this.chartData.summaryLineData = new SummaryLineDataName(item.line.name, r.result);
                    if (this.zoomStartDate && this.zoomEndDate){
                        // console.log(r, this.zoomStartDate, this.zoomEndDate, 'selectChart')
                        this.helper.wait(() => this.summaryLineChartXAxis.zoomToDates(this.zoomStartDate, this.zoomEndDate), 50)
                    }
                }
                this.dataExchange.setLoadSummaryLineData(new LoadingSummaryLineDataGUID(this.sharedGUID, item.line, false, true));
                this.loadingSummaryLineData = false;
                this.helper.wait( () => this.calcChartsDimensions(),1000);
            }, error => {
                console.error(error);
                this.dataExchange.setLoadSummaryLineData(new LoadingSummaryLineDataGUID(this.sharedGUID, item.line, false, true));
                this.loadingSummaryLineData = false;
            })
        }
    };

    //# get message from service for update line visibility for line chart in main and compare chart
    private updateLineVisibility = (data: { type: BGChartType, sharedGUID: string, lineName: string, chart: string }): void => {
        if (data && data.type === this.type && data.sharedGUID === this.sharedGUID){
            let lineName = data.lineName;
            // TODO
            if (data.chart === 'lines'){
                let lines = this.dataExchange.getChartLinesData(this.sharedGUID);
                let line;
                if (lines){
                    line = lines.chartLines.find(item => item.name === lineName);
                }

                if (!line || line.hideLineInLegend && line.name !== 'targetStockLevel'){
                    return;
                }

                line.enabled ? this.lines[lineName].show() : this.lines[lineName].hide();

                const enableRightAxis = (enabled: boolean): void => {
                    this.rightAxis = enabled;
                }

                if (lineName === 'replenishmentTime'){
                    this.chartYAxisRepTime.disabled = !line.enabled;
                    this.chartYAxisLifeTime.disabled = this.chartYAxisBalanceAm.disabled = true;
                    this.chartYAxisRepTime.start = 0;
                    this.chartYAxisRepTime.end = 1;
                    this.disableLegend('balanceAmount');
                    this.disableLegend('saleAmount');
                    this.disableLegend('lifeTime');
                    this.lines['balanceAmount'] && this.lines['balanceAmount'].hide();
                    this.lines['saleAmount'] && this.lines['saleAmount'].hide();
                    this.lines['lifeTime'] && this.lines['lifeTime'].hide();
                    enableRightAxis(line.enabled)
                } else if (lineName === 'lifeTime'){
                    this.chartYAxisLifeTime.disabled = !line.enabled;
                    this.chartYAxisRepTime.disabled = this.chartYAxisBalanceAm.disabled = true;
                    this.chartYAxisLifeTime.start = 0;
                    this.chartYAxisLifeTime.end = 1;
                    this.disableLegend('balanceAmount');
                    this.disableLegend('saleAmount');
                    this.disableLegend('replenishmentTime');
                    this.lines['balanceAmount'] && this.lines['balanceAmount'].hide();
                    this.lines['saleAmount'] && this.lines['saleAmount'].hide();
                    this.lines['replenishmentTime'] && this.lines['replenishmentTime'].hide();
                    enableRightAxis(line.enabled)
                } else if (lineName === 'balanceAmount' || lineName === 'saleAmount'){
                    let amLines = lines.chartLines.filter(item => item.name === 'balanceAmount' || item.name === 'saleAmount');
                    this.chartYAxisBalanceAm.disabled = amLines.every(l => !l.enabled);
                    this.chartYAxisRepTime.disabled = this.chartYAxisLifeTime.disabled = true;
                    this.chartYAxisBalanceAm.start = 0;
                    this.chartYAxisBalanceAm.end = 1;
                    this.disableLegend('replenishmentTime');
                    this.disableLegend('lifeTime');
                    this.lines['replenishmentTime'] && this.lines['replenishmentTime'].hide();
                    this.lines['lifeTime'] && this.lines['lifeTime'].hide();
                    enableRightAxis(amLines.some(l => l.enabled))
                }

                this.helper.wait(this.calcChartsDimensions, 1000);
            } else if (data.chart === 'bubble'){
                let lines = this.dataExchange.getChartLinesData(this.sharedGUID);
                let line;
                if (lines){
                    line = lines.bubbleChartLines.find(item => item.name === lineName);
                }

                if (!line){
                    return;
                }

                line.enabled ? this.bubbleLines[lineName].show() : this.bubbleLines[lineName].hide();
                // line.enabled = !line.enabled;
            } else if (data.chart === 'summaryChartLine'){
                let line = this.infoChartLine.find(item => item.name === lineName);
                line.enabled ? this.linesChartLine[lineName].hide() : this.linesChartLine[lineName].show();
                line.enabled = !line.enabled;

                if (line.name === 'skusCount'){
                    let idsLine = this.infoChartLine.find(item => item.name === 'idsCount')
                    if (!idsLine.enabled){
                        this.linesChartLine['idsCount'].show();
                        idsLine.enabled = true;
                    }
                } else if (line.name === 'idsCount'){
                    let skusLine = this.infoChartLine.find(item => item.name === 'skusCount'),
                        wrhsLine = this.infoChartLine.find(item => item.name === 'wrhsCount');
                    if (!skusLine.enabled){
                        this.linesChartLine['wrhsCount'].show();
                        this.linesChartLine['skusCount'].show();
                        wrhsLine.enabled = skusLine.enabled = true;
                    }

                }
            }

        }
    }

    //# disable current legend in info
    private disableLegend = (lineName: string): void => {
        let lines = this.dataExchange.getChartLinesData(this.sharedGUID)
        if (!lines){
            return;
        }

        let line = lines.chartLines.find(cl => cl.name === lineName);

        if (!line){
            return;
        }

        line.enabled = false;
    };


    // Updates values for info, line chart
    /*private updateStaticPopup = (dateAxis: any = null): void => {
        let date: string = '';
        this.chart.series.each((series) => {
            date = date ? date : this.getDate(series, dateAxis);
            let line: ChartLineModel = this.info.find(item => series.dummyData.name === item.name);

            if (!line){
                return
            }
            if (series.visible){
                let dataItem: any = this.getDataItem(series, dateAxis);

                if (!dataItem){
                    return;
                }

                if (dataItem["valueY"] === undefined || dataItem["valueY"] === null){
                    line.value = this.translates.NoData;
                } else{
                    switch (line.name){
                        case 'actionBuffer':
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.bufferG);
                            break;
                        case 'bufferG':
                            // line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.safetyBuffer - dataItem.dataContext.actionSafetyBuffer);
                            line.value = this.chart.numberFormatter.format(dataItem.dataContext.actionBuffer - dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'bufferY':
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'bufferR':
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'safetyBuffer':
                            line.value = this.chart.numberFormatter.format(dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'actionSafetyBuffer':
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.safetyBuffer);
                            break;
                        default:
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"]);
                    }
                }
            } else{
                line.value = this.translates.OffShort;
            }
        });

        this.updateStaticPopupBubble(date)
    };*/

    // Updates values for info, bubble chart
    /*private updateStaticPopupBubble = (date: string): void => {
        if (!this.bubbleChart){
            return;
        }

        this.bubbleChart.series.each((series) => {
            let line: ChartLineModel = this.infoBubble.find(item => series.dummyData.name === item.name);

            if (!line){
                return
            }

            let cDate = moment(date).format('YYYY-MM-DD') + 'T00:00:00Z';

            // if (series.visible){
            line.value = this.bubbleChartData.find(item => item[series.dummyData.name] && cDate === item.date) ? '1' : '';
            // }
        })
    };*/

    //# get date item obj from date axis and set date for info header
    /*private getDate = (series: any, dateAxis: any): string => {
        let dataItem: any = this.getDataItem(series, dateAxis);

        if (!dataItem || dataItem && !dataItem['dateX']){
            return ''
        }

        if (['ru', 'uk', 'lt', 'pl'].includes(this.translateService.currentLang)){
            this.stpDate = moment(dataItem['dateX']).format('DD.MM.YYYY')
        } else{
            this.stpDate = moment(dataItem['dateX']).format('YYYY.MM.DD')
        }
        return dataItem['dateX'];
    };*/

    //# get date item obj from date axis
    /*private getDataItem = (series: any, dateAxis: any): any => {
        let dataItem: any;

        if (dateAxis){
            dataItem = dateAxis.getSeriesDataItem(
                series,
                dateAxis.toAxisPosition(this.chart.cursor.xPosition),
                true
            );
        } else{
            dataItem = series.dataItems.last;
        }

        return dataItem
    }*/

    /**
     * toggle target level line
      * @param show
     */
    private showTargetLevel = (show: boolean): void => {
        show ? this.lines.targetStockLevel.show() : this.lines.targetStockLevel.hide();
    };

    /*public emit = (emit: boolean): void => {
        if (emit){
            // this.pushData.emit({columnsView: this.columnsView, columnsParameters: this.columnsParameters, columnsHidden: this.columnsHidden});
        }
    }*/

    public toggleLegendShow = (): void => {
        this.legendVisible = !this.legendVisible;
    }

    private updateLgHeight = (): void => {
        // console.log(this.legenddiv.nativeElement.offsetHeight, 'this.legenddiv.nativeElement.offsetHeight')
        // this.lgHeight = this.legenddiv.nativeElement.offsetHeight;
    }

    //# generate bubble chart
    private generateBubbleChart = () => {
        this.bubbleChart = am4core.create('bubble-' + this.GUID, am4charts.XYChart);

        this.bubbleChart.paddingTop = 0;
        // this.chart.padding(0, 0, 0, 0);

        this.chart.resizable = true;

        if (this.translateService.currentLang === 'ru'){
            this.bubbleChart.language.locale = am4lang_ru_RU;
        }

        this.bubbleChart.data = this.bubbleChartData;
        this.bubbleChart.zoomOutButton.disabled = true;

        // Create axes
        this.bubbleChartXAxis = this.bubbleChart.xAxes.push(new am4charts.DateAxis());
        this.bubbleChartXAxis.dataFields.valyeY = name;
        this.bubbleChartXAxis.renderer.grid.template.strokeOpacity = 0;

        this.bubbleChartXAxis.renderer.axisFills.interactionsEnabled = true;

        this.hideAxis(this.bubbleChartXAxis);

        this.bubbleChartYAxis = this.bubbleChart.yAxes.push(new am4charts.ValueAxis());

        this.bubbleChartYAxis.renderer.grid.template.strokeOpacity = 0;
        this.bubbleChartYAxis.hidden = true;
        this.bubbleChartYAxis.min = 0;
        this.bubbleChartYAxis.tooltip.disabled = true;
        this.bubbleChartYAxis.renderer.axisFills.interactionsEnabled = true;

        if (this.bubbleLinesQnt){
            this.bubbleChartYAxis.max = this.bubbleLinesQnt + 1;
        }


        this.setDatesDisplayProps(this.bubbleChart, this.bubbleChartXAxis);

        this.bubbleChartLines.forEach((item, i) => {
            this.addLineBubbleChart(item.name, item.color, item.areaFilledOnLine, item.showBulletOnLine, item.hideLineInLegend, item.showLineByDefault, item.lineName, i);
        });

        this.bubbleChart.legend = new am4charts.Legend();
        this.bubbleChart.legend.itemContainers.template.togglable = false;

        const resizeLegend = (): void => {
            document.getElementById('bubble-legend-' + this.GUID).style.height = this.bubbleChart.legend.contentHeight + "px";
        };

        let legendContainer = am4core.create('bubble-legend-' + this.GUID, am4core.Container);
        legendContainer.width = am4core.percent(100);
        legendContainer.height = am4core.percent(100);
        //
        this.bubbleChart.legend.parent = legendContainer;

        this.bubbleChart.events.on("appeared", resizeLegend);

        this.bubbleChart.events.on("sizechanged", resizeLegend);


        this.bubbleChart.legend.useDefaultMarker = true;

        let marker = this.bubbleChart.legend.markers.template.children.getIndex(0);
        marker.adapter.add("fill", this.legendColors);

        const updateLines = (): void => {
            let lines = this.dataExchange.getChartLinesData(this.sharedGUID);
            if (lines){
                this.updateBubbleChartLines(lines.bubbleChartLines)
            }
        }

        this.bubbleChart.events.on("ready", () => {
            this.bubbleChartReady = true;

            updateLines()
            this.loading.emit(false);
        });

        this.bubbleChart.events.on("validated", () => {
            if (this.bubbleChartReady){
                updateLines()
                this.loading.emit(false);
            }
        });

        this.addBubbleChartCursor();
    }

    /**
     * Add cursor for bubble chart
     */
    private readonly addBubbleChartCursor = (): void => {
        this.bubbleChart.cursor = new am4charts.XYCursor();
        this.bubbleChart.cursor.lineY.disabled = true;

        this.bubbleChart.cursor.events.on("cursorpositionchanged", (ev) => {
            if (this.blockBubbleChartCursor){
                this.blockBubbleChartCursor = false;
                return;
            }
            this.setCursorToChart(ev,  'bubble')
        });
    }

    //# generate data for bubble chart
    private generateBubbleChartData = (): void => {

        this.bubbleChartData = this.chartData.rows.map(r  =>  {return {}});

        this.bubbleLinesQnt = 0;

        let lines = this.dataExchange.getChartLinesData(this.sharedGUID);

        if (!lines){
            console.error('Not found lines!')
            return;
        }

        let reverse = lines.bubbleChartLines.map(ib => ib).reverse();
        reverse.forEach(inItem => {
            if (this.chartData.rows.some(r => r[inItem.name])){
                this.bubbleLinesQnt = this.bubbleLinesQnt + 1;
                this.chartData.rows.forEach((item, i) => {
                    this.bubbleChartData[i][inItem.name] = item[inItem.name] ? this.bubbleLinesQnt : null;
                    this.bubbleChartData[i].date = item.date;
                })
            }
        });

        if (this.bubbleChart){
            this.bubbleChart.dispose();
            this.bubbleChart = null;
        }

        this.generateBubbleChart();

    };

    //# add lines for bubble chart
    private addLineBubbleChart = (name: string, color: string, isFilled: boolean, showBullet: boolean, defaultColumn: boolean, defaultVisibility: boolean, displayName: string, idx: number): void => {

        this.bubbleLines[name] = this.bubbleChart.series.push(new am4charts.LineSeries());

        let line = false;

        this.bubbleLines[name].showOnInit = false;
        this.bubbleLines[name].dataFields.valueY = name;
        this.bubbleLines[name].dataFields.dateX = "date";
        this.bubbleLines[name].strokeOpacity = 0;
        this.bubbleLines[name].cursorTooltipEnabled = false;
        this.bubbleLines[name].fill = am4core.color(color);
        this.bubbleLines[name].tooltip.pointerOrientation = 'horizontal';
        if (!line){
            this.bubbleLines[name].interpolationDuration = 0;
            this.bubbleLines[name].defaultState.transitionDuration = 0;
            this.bubbleLines[name].hiddenState.transitionDuration = 0;
        }

        this.bubbleLines[name].name = displayName;
        this.bubbleLines[name].stroke = am4core.color(color);
        this.bubbleLines[name].hiddenInLegend = defaultColumn;


        if (!line){
            this.bubbleLines[name].bulletData = this.bubbleLines[name].bullets.push(new am4charts.CircleBullet());
            this.bubbleLines[name].bulletData.hiddenState.properties.scale = 0.01;
            this.bubbleLines[name].bulletData.hiddenState.properties.opacity = 0.7;
            this.bubbleLines[name].bulletData.tooltipText = `${displayName}: {dateX}`;
            this.bubbleLines[name].bulletData.tooltipPointerOrientation = 'up';
            this.bubbleLines[name].bulletData.circle.radius = 3;
        }

        if (line){
            this.bubbleLines[name].showOnInit = true;
            this.bubbleLines[name].strokeOpacity = 1;

            let segment = this.bubbleLines[name].segments.template;
            segment.interactionsEnabled = true;

            let hs = segment.states.create("hover");
            hs.properties.strokeWidth = 5;
            this.bubbleLines[name].segments.template.strokeWidth = 1;
        }


        let shadow = false;

        this.bubbleLines[name].dummyData = {color, displayName, name, shadow};

        this.bubbleLines[name].bulletHover = this.bubbleLines[name].bulletData.states.create("hover");
        this.bubbleLines[name].bulletHover.properties.scale = 1.5;

        this.bubbleLines[name].innerCircle = this.bubbleLines[name].bulletData.createChild(am4core.Circle);
        this.bubbleLines[name].innerCircle.verticalCenter = "middle";
        this.bubbleLines[name].innerCircle.horizontalCenter = "middle";

        this.bubbleLines[name].innerCircle.radius = 1;
        this.bubbleLines[name].innerCircle.fill = am4core.color("#fff");

        this.bubbleLines[name].innerCircle.stroke = am4core.color("#fff");
        this.bubbleLines[name].innerCircle.strokeWidth = 0;
        this.bubbleLines[name].innerCircle.strokeOpacity = 1;
    };

    /*public hoverBubbleLine = (series: any, enter: boolean): void => {
        series.bulletData.isHover = enter;
    }*/

    public toggleLegendBubbleShow = (): void => {
        this.legendBubbleVisible = !this.legendBubbleVisible;
    };

    //# toggle show bubble chart on main and compare chart
    public toggleBubbleShow = (): void => {
        this.dataExchange.setToggleBubbleChart({
            type: this.type,
            sharedGUID: this.sharedGUID,
            show: !this.bubbleVisible
        });
    };

    //# research no use
    private toggleShadowAllBubbles = (name: string): void => {
        if (!this.bubbleLines[name].dummyData.shadow){
            let series = this.bubbleChart.series.push(new am4charts.LineSeries()),
                bullet = series.bullets.push(new am4charts.CircleBullet()),
                square = bullet.createChild(am4core.Rectangle);

            square.invalidate();
            this.bubbleLines[name].bulletData.filters.clear();
        }

        this.bubbleLines[name].dummyData.shadow = !this.bubbleLines[name].dummyData.shadow;
    };

    public updateCursor = (): void => {
        if (this.chart && this.chart.cursor){
            this.chart.cursor.selection.hide();
            this.chart.cursor.dispose();
        }

        this.addMainChartCursor();
    }

    //# update data for line and bubble chart
    private updateChartData = (dataModel: ChartSetDataModel): void => {
        if (!dataModel || dataModel.GUID !== this.GUID){
            return;
        }

        // console.log(dataModel,this.GUID, this.isMainChart, 'updateChartData')

        if (!this.chartData.startDate.isSame(dataModel.data.startDate) ||
            !this.chartData.endDate.isSame(dataModel.data.endDate)){
            this.dataExchange.setAggRange(new RangeAggGUID(this.sharedGUID, null));
            // console.log(this.chartData.startDate, dataModel.data.startDate,
            //     this.chartData.endDate.format(this.helper.en_Date), dataModel.data.endDate.format(this.helper.en_Date), 'Work')
            this.savedZoom = null;
            this.zoomStartDate = null;
            this.zoomEndDate = null;
        }

        this.chartData = dataModel.data;
        this.itemId = dataModel.data.itemInfo.itemId;
        this.chart.data = this.chartData.rows;
        this.chartYAxis.start = 0;
        this.chartYAxis.end = 1;

        let lines = this.dataExchange.getChartLinesData(this.sharedGUID);

        if (!lines){
            return;
        }

        lines.chartLines.forEach(line => {
            if (line.name === 'replenishmentTime' && line.enabled){
                this.updateLineVisibility({
                    type: this.type,
                    sharedGUID: this.sharedGUID,
                    lineName: 'replenishmentTime',
                    chart: 'lines'
                });
                this.helper.wait(() => this.updateLineVisibility({
                    type: this.type,
                    sharedGUID: this.sharedGUID,
                    lineName: 'replenishmentTime',
                    chart: 'bubble'
                }), 10)
            }
        })
        this.generateBubbleChartData();
        this.bubbleChart.data = this.bubbleChartData;
        this.bubbleChart.validateData();
        this.dataExchange.updateChartObj(new UpdateChartGUID(
            this.sharedGUID,
            this.chart,
            this.chartXAxis,
            this.chartData,
            this.bubbleChart,
            this.bubbleChartXAxis,
            this.bubbleChartData,
            this.isMainChart
        ));

        this.axisChart.data = this.chartData.rows.map(r => {
            return {date: r.date, actionBalance: r.actionBalance}
        });
        this.updateCWHItemId();

        if (this.type === BGChartType.Summary && this.summaryLineSelected){
            this.summaryLineSelected.summaryLineSelected = false;
            this.selectChart(new LoadingSummaryLineDataGUID(this.sharedGUID, this.summaryLineSelected, true, false));
        }

        this.helper.wait(this.calcChartsDimensions, 1000);
    };

    //# no use
    /*public showWrhListFunc = (): void => {
        if (!this.showWrhList){
            this.showWrhList = true;
        }
        this.showCustomLists = false;
    };*/

    //# add compare chart
    public addCompareChart = (itemId: number): void => {
        if (!this.isMainChart){
            return;
        }

        let newChart = new AddChartModel(itemId, this.helper.generateGUID(), this.sharedGUID, this.type);
        newChart = this.setToNewChartDates(newChart);
        this.dataExchange.setAddChart(newChart);
        this.showCustomLists = false;
        this.hideCompareBtn = true;
    };

    //# add dates from period selector to compare chart
    private setToNewChartDates = (newChart: AddChartModel): AddChartModel => {
        newChart.startDate = this.chartPeriodSelector.startDate;
        newChart.endDate = this.chartPeriodSelector.endDate;
        return newChart;
    }

    //# show custom chart add form
    public showCustomList = (): void => {
        if (this.showCustomLists){
            this.customListsPopper.destroy();
            this.customListsPopper = null;
            this.showCustomLists = false;
        } else{
            this.showCustomLists = true;
            this.customListsPopperCreate = true;
        }
    };

    //# set date display format for chart
    private setDatesDisplayProps = (chart: any, axis: any): void => {
        chart.dateFormatter.dateFormat = "dd-MM-yyyy";
        axis.dateFormats.setKey("day", "dd.MM.yyyy");
        axis.periodChangeDateFormats.setKey("day", "dd.MM.yyyy");
        axis.dateFormats.setKey("month", "MMM yyyy");
        axis.periodChangeDateFormats.setKey("month", "MMM yyyy");
        axis.dateFormats.setKey("week", "dd.MM.yyyy");
        axis.periodChangeDateFormats.setKey("week", "dd.MM.yyyy");
    }

    //# add popper to compare custom chart form
    public popperAdd = (): void => {
        if (!this.customListBtn || !this.customListsWrp){
            return;
        }

        this.customListsPopper = new Popper(this.customListBtn.nativeElement, this.customListsWrp.nativeElement, {
            placement: 'bottom-end',
            modifiers: {
                flip: {
                    behavior: ['bottom-end']
                },
                preventOverflow: {
                    boundariesElement: this.mainWrapperRef.nativeElement,
                },
            },
        });
    };

    //# add popper for chart compare buttons wrapper
    public comparePopperAdd = (): void => {

        if (!this.isMainChart){
            return;
        }
        this.compareButtonsPopper = new Popper(this.showCompBtn.nativeElement, this.btnWrpCompare.nativeElement, {
            placement: 'bottom-end',
            modifiers: {
                flip: {
                    behavior: ['bottom-end']
                },
                preventOverflow: {
                    boundariesElement: this.mainWrapperRef.nativeElement,
                },
            },
        });
    };

    //# updates popper add compare chart form
    public popperUpd = (): void => {
        this.compareButtonsPopper ? this.compareButtonsPopper.update() : null;
        this.customListsPopper.update();
    };

    //# close compare chart
    public close = (): void => {
        if (this.isMainChart){
            return;
        }

        this.closeOut.emit(true);
    }

    //# toggle Info Show for main chart and compare chart
    /*public toggleInfoShow = (): void => {
        this.dataExchange.setToggleChartInfo({type: this.type, sharedGUID: this.sharedGUID, show: !this.showInfo});
        this.compareButtonsPopperUpdate = true;
        this.customListsPopperCreate = true;
        //this.showInfo = !this.showInfo;
    }*/

    //# sync lines between main and compare chart
    private sendLinesPropsToCompareChart = (data: { command: string, type: string, sharedGUID: string, lines: ChartLineModel[] }): void => {
        if (this.isMainChart && data.sharedGUID === this.sharedGUID){
            this.dataExchange.setCompareChartReady({
                command: 'update',
                type: this.type,
                sharedGUID: this.sharedGUID,
                lines: data.lines
            })
        }
    }

    //# set lines from main to compare chart
    private setLinesProps = (data: { command: string, type: string, sharedGUID: string, lines: ChartLineModel[] }): void => {
        if (!this.isMainChart && data.sharedGUID === this.sharedGUID){
            /*this.info.forEach(item => {
                data.lines.forEach(inItem => {
                    if (item.name === inItem.name){
                        item.enabled = inItem.enabled;
                    }
                })
            })*/

            this.updateChartLines(data.lines);
        }
    }

    //# research
    /*public hoverLine = (series: any, enter: boolean): void => {
        series.segments.each((segment) => {
            segment.isHover = enter;
        });
    }*/

    /**
     * Generate line graph
     */
    private readonly generateLineGraph = (): void => {
        if (this.type !== BGChartType.Summary){
            return
        }

        /* Chart code */

        this.infoChartLine = this.helper.getSummaryLieChartLines();
        am4core.useTheme(am4themes_animated);
        this.summaryLineChart = am4core.create('linechart', am4charts.XYChart)
        this.summaryLineChart.colors.step = 2;
        // this.summaryLineChart.tooltip.background.fill = am4core.color("#bcc2be")
        this.summaryLineChart.maskBullets = false;
        this.summaryLineChart.zoomOutButton.disabled = true;
        this.summaryLineChart.paddingRight = 5;

        this.summaryLineChart.events.on("validated", () => {
            this.calcChartsDimensions();
        })
        this.linesChartLine = {};

        // Add data
        this.summaryLineChart.data = [];

        // Create axes
        this.summaryLineChartXAxis = this.summaryLineChart.xAxes.push(new am4charts.DateAxis());
        this.summaryLineChartXAxis.renderer.axisFills.interactionsEnabled = true;

        this.hideAxis(this.summaryLineChartXAxis);

        this.setDatesDisplayProps(this.summaryLineChart, this.summaryLineChartXAxis)

        this.summaryLineChartYAxis = this.summaryLineChart.yAxes.push(new am4charts.ValueAxis());

        this.summaryLineChartYAxis2 = this.summaryLineChart.yAxes.push(new am4charts.ValueAxis());
        this.summaryLineChartYAxis2.renderer.opposite = true;
        // this.summaryLineChartYAxis2.syncWithAxis = this.summaryLineChartYAxis;
        this.summaryLineChartYAxis2.renderer.labels.template.fill = am4core.color("#e3000f");
        this.summaryLineChartYAxis2.renderer.grid.template.strokeOpacity = 1;
        this.summaryLineChartYAxis2.renderer.grid.template.stroke = am4core.color("#e3000f");
        this.summaryLineChartYAxis2.renderer.grid.template.strokeWidth = 1;
        this.summaryLineChartXAxis.renderer.axisFills.interactionsEnabled = true;

        // Create series
        let distanceSeries = this.summaryLineChart.series.push(new am4charts.ColumnSeries());
        distanceSeries.dataFields.valueY = "wrhsCount";
        distanceSeries.dataFields.dateX = "date";
        distanceSeries.yAxis = this.summaryLineChartYAxis2;
        // distanceSeries.tooltipText = `[bold]${this.translates.Warehouses}[/]: {wrhsCount}`;
        distanceSeries.name = this.translates.Warehouses;

        distanceSeries.columns.template.fillOpacity = 0.7;
        distanceSeries.columns.template.propertyFields.strokeDasharray = "dashLength";
        distanceSeries.columns.template.propertyFields.fillOpacity = "alpha";
        distanceSeries.showOnInit = true;
        distanceSeries.stroke = am4core.color('#6fa9c1');
        distanceSeries.fill = am4core.color('#6fa9c1');
        distanceSeries.tooltip.getFillFromObject = false;
        distanceSeries.tooltip.label.propertyFields.fill = "color";
        distanceSeries.tooltip.background.propertyFields.stroke = "color";

        // distanceSeries.columns.template.tooltipX = am4core.percent(0);
        // distanceSeries.columns.template.tooltipY = -100;
        distanceSeries.tooltip.pointerOrientation = "vertical";
        // distanceSeries.tooltip.dy = -5;

        let distanceState = distanceSeries.columns.template.states.create("hover");
        distanceState.properties.fillOpacity = 0.9;
        this.linesChartLine['wrhsCount'] = distanceSeries;

        // Create series
        let distanceSeries2 = this.summaryLineChart.series.push(new am4charts.ColumnSeries());
        distanceSeries2.dataFields.valueY = "skusCount";
        distanceSeries2.dataFields.dateX = "date";
        distanceSeries2.yAxis = this.summaryLineChartYAxis2;
        // distanceSeries2.tooltipText = `[bold]${this.translates.Goods}[/]: {valueY}`;
        distanceSeries2.name = this.translates.Goods;
        distanceSeries2.columns.template.fillOpacity = 0.7;
        distanceSeries2.columns.template.propertyFields.strokeDasharray = "dashLength";
        distanceSeries2.columns.template.propertyFields.fillOpacity = "alpha";
        distanceSeries2.showOnInit = true;
        distanceSeries2.stroke = am4core.color('#87cefa');
        distanceSeries2.fill = am4core.color('#87cefa');
        distanceSeries2.tooltip.getFillFromObject = false;
        distanceSeries2.tooltip.label.propertyFields.fill = "color";
        distanceSeries2.tooltip.background.propertyFields.stroke = "color";
        // distanceSeries2.columns.template.tooltipX = am4core.percent(0);
        // distanceSeries2.columns.template.tooltipY = 100;
        distanceSeries2.tooltip.pointerOrientation = "vertical";

        let distanceState2 = distanceSeries2.columns.template.states.create("hover");
        distanceState2.properties.fillOpacity = 0.9;

        this.linesChartLine['skusCount'] = distanceSeries2;

        let durationSeries = this.summaryLineChart.series.push(new am4charts.LineSeries());
        durationSeries.dataFields.valueY = "idsCount";
        durationSeries.dataFields.dateX = "date";
        durationSeries.yAxis = this.summaryLineChartYAxis;
        durationSeries.name = this.translates.Rows;
        durationSeries.strokeWidth = 2;
        durationSeries.propertyFields.strokeDasharray = "dashLength";
        // durationSeries.tooltipText = `[bold]${this.translates.Rows}[/]: {valueY}`;
        durationSeries.showOnInit = true;
        durationSeries.stroke = am4core.color('#87cefa');
        durationSeries.fill = am4core.color('#87cefa');
        durationSeries.tooltip.getFillFromObject = false;
        durationSeries.tooltip.label.propertyFields.fill = "color";
        durationSeries.tooltip.background.propertyFields.stroke = "color";
        durationSeries.tooltip.pointerOrientation = "vertical"
        // durationSeries.columns.template.tooltipX = am4core.percent(0);
        // durationSeries.columns.template.tooltipY = am4core.percent(0);
        this.linesChartLine['idsCount'] = durationSeries;
        this.addSummaryLineChartTooltips();
        this.addSummaryLineChartCursor();
    }

    /**
     * Add custom tooltip for line
     * @param series - of the line chart
     */
    private readonly addCustomTooltipForLineChart = (series: any): void => {
        series.adapter.add("tooltipText", (text2) => {
            let text = '';
            this.summaryLineChart.series.each(item => {
                if (!item.isHidden) {
                    text += `[${item.stroke.hex}]● [/]  [${item.stroke.hex}]${item.name}:[/] [${item.stroke.hex}]{${item.dataFields.valueY}}[/]\n`;
                }
            });
            return text;
        });
    }

    /**
     * Add tooltips for summary list line
     */
    public readonly addSummaryLineChartTooltips = (): void => {
        this.addCustomTooltipForLineChart(this.linesChartLine['wrhsCount']);
        this.addCustomTooltipForLineChart(this.linesChartLine['skusCount']);
        this.addCustomTooltipForLineChart(this.linesChartLine['idsCount']);
    }

    /**
     * Remove tooltips from summary list line
     */
    public readonly removeSummaryLineChartTooltips = (): void => {
        // console.log('removeSummaryLineChartTooltips')
        this.linesChartLine['wrhsCount'].adapter.remove("tooltipText");
        this.linesChartLine['skusCount'].adapter.remove("tooltipText");
        this.linesChartLine['idsCount'].adapter.remove("tooltipText");
    }

    /**
     * Add cursor for summary line chart
     */
    private readonly addSummaryLineChartCursor = (): void => {
        this.summaryLineChart.cursor = new am4charts.XYCursor();
        this.summaryLineChart.cursor.fullWidthLineX = true;
        // this.summaryLineChart.cursor.maxTooltipDistance = 100;
        this.summaryLineChart.cursor.maxTooltipDistance = 0;

        this.summaryLineChart.cursor.events.on("cursorpositionchanged", (ev) => {
            if (this.blockSummaryLineChartCursor){
                this.blockSummaryLineChartCursor = false;
                return;
            }
            this.setCursorToChart(ev,  'summaryLine')
        });
    }

    /**
     * Generate chart axis for show dates
     */
    private readonly generateAxisChart = (): void => {
        am4core.useTheme(am4themes_animated);
        this.axisChart = am4core.create('axischart_' + this.GUID, am4charts.XYChart);
        this.axisChart.zoomOutButton.disabled = true;

        this.axisChart.language.locale = this.getChartLocale(this.translateService.currentLang);

        this.axisChartXAxis = this.axisChart.xAxes.push(new am4charts.DateAxis());
        this.axisChartXAxis.renderer.axisFills.interactionsEnabled = true;

        this.axisChartYAxis = this.axisChart.yAxes.push(new am4charts.ValueAxis());

        this.setDatesDisplayProps(this.axisChart, this.axisChartXAxis);

        this.axisChart.data = this.chartData.rows.map(r => {
            return {date: r.date, actionBalance: r.actionBalance}
        });

        let distanceSeries = this.axisChart.series.push(new am4charts.ColumnSeries());
        distanceSeries.dataFields.valueY = "actionBalance";
        distanceSeries.dataFields.dateX = "date";

        this.addAxisChartCursor();
    }

    /**
     * Add cursor for axis chart
     */
    private readonly addAxisChartCursor = (): void => {
        this.axisChart.cursor = new am4charts.XYCursor();
        this.axisChart.cursor.lineY.disabled = true;
    }

    public showTabsListFunc = (): void => {
        this.showTabsList = !this.showTabsList;
    }

    /*private lineTable = (): { tWidth: string[], tBody: any[] }[] => {
        let fullInfo = this.info.concat(this.infoBubble);

        const formTable = (info: ChartLineModel[]): { tWidth: string[], tBody: any[] } => {
            let tHeader = info.map(item => {
                return {text: item.lineName, bold: true, style: 'tHeader'}
            });

            tHeader.unshift({text: this.translates.Date, bold: true, style: 'tHeader'});
            let tWidth: any[] = info.map(() => 30);
            tWidth.unshift('auto');

            let tBody: any[] = [];

            tBody.push(tHeader);

            let tData = this.chartData.rows.map(item => {
                let row: any[] = [];
                row.push(Formatters.dateFormatterConv(null, null, item.date));
                info.forEach(inItem => {
                    row.push(item[inItem.name]);
                });
                return row;
            });

            tBody = tBody.concat(tData);
            return {tWidth: tWidth, tBody: tBody};
        };

        let res: { tWidth: string[], tBody: any[] }[] = [];

        res.push(formTable(fullInfo.filter((item, i) => i < Math.round(fullInfo.length / 2))));
        res.push(formTable(fullInfo.filter((item, i) => i >= Math.round(fullInfo.length / 2))));
        return res;
    }*/

    /**
     * Hide tooltip for axis
     */
    private hideAxisTooltip = (axis: any): void => {
        if (!axis){
            return;
        }

        let axisTooltip = axis.tooltip;
        axisTooltip.background.fill = am4core.color("rgba(0, 0, 0, 0.0)");
        axisTooltip.label.fill = am4core.color("rgba(255, 255, 255, 0)");
        axisTooltip.background.strokeWidth = 0;
        axisTooltip.background.pointerLength = 0;
    }

    /**
     * Show tooltip for axis
     */
    private showAxisTooltip = (axis: any): void => {
        if (!axis){
            return;
        }
        let axisTooltip = axis.tooltip;
        axisTooltip.background.fill = am4core.color("rgba(0, 0, 0, 1)");
        axisTooltip.label.fill = am4core.color("rgba(255, 255, 255, 1)");
        axisTooltip.background.strokeWidth = 1;
        axisTooltip.background.pointerLength = 1;
    }

    /**
     * Show tooltip for chart axis
     */
    public readonly showSummaryChartLineAxisTooltip = (): void => {
        this.showAxisTooltip(this.summaryLineChartYAxis);
        this.showAxisTooltip(this.summaryLineChartYAxis2);
    }

    /**
     * Hide tooltip for chart axis
     */
    public readonly hideSummaryChartLineAxisTooltip = (): void => {
        this.hideAxisTooltip(this.summaryLineChartYAxis);
        this.hideAxisTooltip(this.summaryLineChartYAxis2);
    }

    /**
     * Show and hides tooltips on charts if mouse on it
     * @param e
     * @param type - chart type
     */
    public readonly chartMouseEnter = (e: MouseEvent, type: BGChartType): void => {
        // console.log(e, e.target, 'chartMouseEnter');
        this.calcChartsDimensions();
        if (this.chart && this.chart.cursor){
            this.chart.cursor.lineX.strokeOpacity = 0;
        }

        if (this.bubbleChart && this.bubbleChart.cursor){
            this.bubbleChart.cursor.lineX.strokeOpacity = 0;
        }



        if (type === BGChartType.MainChart){
            this.chartYAxis && this.showAxisTooltip(this.chartYAxis);
            this.getActiveAxis() && this.showAxisTooltip(this.getActiveAxis());
            if (this.chart && this.chart.cursor){
                this.chart.cursor.lineY.strokeOpacity = 0.5;
            }

            if (this.type === BGChartType.Summary){
                this.summaryLineChart.cursor.lineY.strokeOpacity = 0;
            }
        }

        if (this.type === BGChartType.Summary){
            if (type === BGChartType.SummaryLineChart){
                this.addSummaryLineChartTooltips();
                this.showAxisTooltip(this.summaryLineChartYAxis);
                this.showAxisTooltip(this.summaryLineChartYAxis2);
                this.chart.cursor.lineY.strokeOpacity = 0;
                this.summaryLineChart.cursor.lineY.strokeOpacity = 0.5;
            } else {
                this.removeSummaryLineChartTooltips();
            }
        }

        this.axisChartXAxis && this.showAxisTooltip(this.axisChartXAxis);
        // console.log(type, this.summaryLineChart.cursor.lineY.strokeOpacity, this.chart.cursor.lineY.strokeOpacity,  'chartMouseEnter 2')
    }

    public readonly getActiveAxis = (): any => {
        if (this.chartYAxisRepTime && !this.chartYAxisRepTime.disabled){
            return this. chartYAxisRepTime;
        } else if (this.chartYAxisLifeTime && !this.chartYAxisLifeTime.disabled){
            return this. chartYAxisLifeTime;
        } else if (this.chartYAxisBalanceAm && !this.chartYAxisBalanceAm.disabled){
            return this. chartYAxisBalanceAm;
        } else {
            return null;
        }
    }

    /**
     * Show or hides tooltips on chart if mouse leave chart
     * @param e
     * @param type - chart type
     */
    public readonly chartMouseLeave = (e: MouseEvent, type: BGChartType): void => {
        // console.log(e, e.target, 'chartMouseLeave');
        // this.chart.cursor.selection.hide();
        if (this.chart && this.chart.cursor){
            this.chart.cursor.lineX.strokeOpacity = 0;
            this.chart.cursor.lineY.strokeOpacity = 0;
        }

        this.chartYAxis && this.hideAxisTooltip(this.chartYAxis);
        this.getActiveAxis() && this.hideAxisTooltip(this.getActiveAxis());

        if (this.bubbleChart && this.bubbleChart.cursor){
            this.bubbleChart.cursor.lineX.strokeOpacity = 0;
        }

        if (this.type === BGChartType.Summary){
            this.hideAxisTooltip(this.summaryLineChartYAxis);
            this.hideAxisTooltip(this.summaryLineChartYAxis2);
            this.summaryLineChart.cursor.lineX.strokeOpacity = 0;
            this.summaryLineChart.cursor.lineY.strokeOpacity = 0;
            this.removeSummaryLineChartTooltips();
        }

        this.axisChartXAxis && this.hideAxisTooltip(this.axisChartXAxis);
    }

    /**
     * calculate chart axis width for chart cursor vertical line lie to identical dates
     * @param val - quantity of numbers in axis
     */
    private readonly getMainChartYAxisLength = (val: number): number => {
        switch (val){
            case 1: return 64;
            case 2: return 64;
            case 3: return 66;
            case 4: return 67;
            case 5: return 75;
            case 6: return 83;
            case 7: return 93;
            case 8: return 100;
        }
    }

    private readonly getMainChartYAxisLengthRight = (val: number): number => {
        switch (val){
            case 1: return 64;
            case 2: return 64;
            case 3: return 68;
            case 4: return 69;
            case 5: return 75;
            case 6: return 83;
            case 7: return 93;
            case 8: return 100;
        }
    }

    /**
     * calculate chart axis width for chart cursor vertical line lie to identical dates
     * @param val - quantity of numbers in axis
     */
    private readonly getSummaryLineChartYAxisLength = (val: number): number => {
        switch (val){
            case 1: return 51;
            case 2: return 57;
            case 3: return 64;
            case 4: return 71;
            case 5: return 82;
            case 6: return 88;
            case 7: return 99;
            case 8: return 104;
        }
    }

    /**
     * set chart dimensions for chart cursor vertical line lie to identical dates
    */
    private readonly calcChartsDimensions = (): void => {
        if (!this.chartYAxis){
            return;
        }

        let mainChartYAxisLength = this.helper.getDigitLength(this.chartYAxis.max),
            mainChartYAxis2Length = this.getActiveAxis() ? this.helper.getDigitLength(this.getActiveAxis().max) : 0,

            chartsWidth = this.mainChartWrp.nativeElement.offsetWidth,
            symbolWidth = 6;

        let summaryLineChartYAxisLength = 0,
            summaryLineChartYAxis2Length = 0;
        if (this.type === BGChartType.Summary){
            summaryLineChartYAxisLength = this.helper.getDigitLength(this.summaryLineChartYAxis.max);
            summaryLineChartYAxis2Length = this.helper.getDigitLength(this.summaryLineChartYAxis2.max);
        }
        const calcMainChartML = (chartYAxisLength: number, chartYAxisLength2?: number): void => {

            this.mainChartMarginLeft = chartYAxisLength;
            this.mainChartWidth = chartsWidth - this.mainChartMarginLeft - 4;

            if (chartYAxisLength2){
                this.mainChartWidth = this.mainChartWidth - (chartYAxisLength2 - 1)*6 - 5
            }

        }

        const calcBubbleML = (chartYAxisLength: number, chartYAxisLength2?: number): void => {
            this.bubbleChartMarginLeft = chartYAxisLength - 53;
            this.bubbleChartWidth = chartsWidth - 21 - this.bubbleChartMarginLeft;
            let rightMargin: number = 0,
                mainChartMargin: number = 0,
                lineChartMargin: number = 0;

            if (this.rightAxis){
                mainChartMargin = this.getMainChartYAxisLength(mainChartYAxis2Length) - 18;
                // this.bubbleChartWidth = this.bubbleChartWidth - this.getMainChartYAxisLength(mainChartYAxis2Length) + 15;
            }

            if (chartYAxisLength2){
                lineChartMargin = (chartYAxisLength2 - 1)*6 + 5;
                // this.bubbleChartWidth = this.bubbleChartWidth - (chartYAxisLength2 - 1)*6 - 5
            }

            rightMargin = mainChartMargin > lineChartMargin ? mainChartMargin : lineChartMargin;
            this.bubbleChartWidth = this.bubbleChartWidth - rightMargin;

        }

        const calcSummaryLineML = (chartYAxisLength): void => {
            let leftSummaryLine = this.getSummaryLineChartYAxisLength(summaryLineChartYAxisLength),
                leftMainChart = this.getMainChartYAxisLength(mainChartYAxisLength);
            this.summaryLineChartNameLeftPosition = (leftSummaryLine >= leftMainChart ? leftSummaryLine : leftMainChart) - 5;
            this.summaryLineChartMarginLeft = chartYAxisLength;
            this.summaryLineChartWidth = chartsWidth - 7 - this.summaryLineChartMarginLeft;

            // console.log(chartYAxisLength, this.summaryLineChartMarginLeft, 'calcSummaryLineML')
            if (this.rightAxis){
                this.summaryLineChartWidth = this.summaryLineChartWidth - this.getMainChartYAxisLengthRight(mainChartYAxis2Length) + 15;
            }
        }

        if (this.summaryLineSelected){
            let diff = this.getMainChartYAxisLength(mainChartYAxisLength) - this.getSummaryLineChartYAxisLength(summaryLineChartYAxisLength);

            if (diff > 0){
                calcBubbleML(this.getMainChartYAxisLength(mainChartYAxisLength), summaryLineChartYAxis2Length);
                calcMainChartML(0, summaryLineChartYAxis2Length);
                calcSummaryLineML(diff);
            } else if (diff < 0) {
                calcBubbleML(this.getSummaryLineChartYAxisLength(summaryLineChartYAxisLength), summaryLineChartYAxis2Length);
                calcMainChartML(diff*-1, summaryLineChartYAxis2Length);
                calcSummaryLineML(0);

            }
        } else {
            if (mainChartYAxisLength){
                calcBubbleML(this.getMainChartYAxisLength(mainChartYAxisLength));
            }
            calcMainChartML(0);
        }

    }

    /**
     * Update line position on mouse enter
     */
    public readonly mouseEnter = (): void => {
        this.entered = true;
        if (!this.chartYAxis){
            return;
        }
        this.horLineLeft = this.getMainChartYAxisLength(this.helper.getDigitLength(this.chartYAxis.max)) - 7;
        let rect: DOMRect = this.chartsWrp.nativeElement.getBoundingClientRect();
        this.horLineTop = this.mainChartWrp.nativeElement.getBoundingClientRect().y - rect.y + 5;
        this.width = this.chartsWrp.nativeElement.offsetWidth - this.horLineLeft;
        this.height = this.mainChartWrp.nativeElement.offsetHeight;
        if (this.bubbleVisible){
            this.height += this.bubbleChartWrp.nativeElement.offsetHeight;
        }

        if (this.summaryLineSelected){
            this.height += this.summaryLineWrp.nativeElement.offsetHeight;
        }

        // console.log(this.mainChartWrp.nativeElement.getBoundingClientRect().y - rect.y, 'mouseEnter');
    }

    public readonly mouseLeave = (): void => {
        this.entered = false;
    }

    /**
     * Update cursor line position on mouse move
     */
    public readonly mouseMove = (e: MouseEvent): void => {
        if (this.timeOut){
            clearTimeout(this.timeOut);
            this.timeOut = null;
        }

        this.timeOut = setTimeout(() => {
            clearTimeout(this.timeOut);
            this.timeOut = null;

            this.top = this.chartsWrp.nativeElement.offsetTop;
            this.left = this.chartsWrp.nativeElement.offsetLeft;
            let rect = this.chartsWrp.nativeElement.getBoundingClientRect()

            // this.x = e.clientX - this.left + 2 + this.chartsWrp.nativeElement.scrollLeft;
            this.x = e.clientX - rect.x - 2;
            this.y = e.clientY - rect.y - 2;
            // this.x = 250;
            // this.y = 250;
            // console.log(this.chartsWrp.nativeElement.getBoundingClientRect(), e, e.clientX, e.clientY, this.left, this.top, 'mouseMove');
            // console.log(this.x, this.y, 'mouseMove');
        }, 10)
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/amchart4.component/amchart4.component.ts